import { Injectable } from '@angular/core';
import * as taiPasswordStrength from 'tai-password-strength';

export interface PasswordStrengthResult {
    charsetSize : number;
    commonPassword : boolean;
    passwordLength : number;
    shannonEntropyBits : number;
    strengthCode : 'VERY_WEAK' | 'WEAK' | 'REASONABLE' | 'STRONG' | 'VERY_STRONG';
    trigraphEntropyBits : number;
    charsets : PasswordCharsets;
}

export interface PasswordCharsets {
    number : boolean;
    lower : boolean;
    upper : boolean;
    punctuation : boolean;
    symbol : boolean;
    other : string;
}

const COMMON_PASSWORDS = [
    "",
    "~!@",
    "~!@#$%",
    "",
    "",
    "__--_-__-_",
    "-",
    "!",
    "!@",
    "!@#",
    "!@#$",
    "!@#$%",
    "!@#$%^",
    "!@#$%^&",
    "!@#$%^&*",
    "!@#$%^&*(",
    "!@#$%^&*()",
    "/.,",
    ".",
    ")",
    ")(",
    ")(*",
    ")(*&",
    ")(*&^",
    ")(*&^%",
    ")(*&^%$",
    ")(*&^%$#",
    ")(*&^%$#@",
    ")(*&^%$#@!",
    "@#$%^&",
    "*",
    "\b",
    "0",
    "000",
    "0000",
    "00000",
    "000000",
    "0000000",
    "00000000",
    "0007",
    "007",
    "007007",
    "010101",
    "010203",
    "0123",
    "0123456",
    "0213",
    "0246",
    "0249",
    "0252324665",
    "061892",
    "0727",
    "0727527122",
    "09",
    "098",
    "0987",
    "09876",
    "098765",
    "0987654",
    "09876543",
    "098765432",
    "0987654321",
    "0ffl1ne",
    "0nl1ne",
    "0o9i8u7y",
    "0ok9ij",
    "0okm9ijn",
    "0p3r4t0r",
    "0p9o8i7u6y5t4r3e2w1q",
    "0plmnko9",
    "0r@cl3",
    "1",
    "100200",
    "102030",
    "1020304050",
    "1022",
    "1029",
    "10293",
    "102938",
    "1029384756",
    "106",
    "10sne1",
    "11",
    "110110",
    "110110jp",
    "111",
    "1111",
    "11111",
    "111111",
    "1111111",
    "11111111",
    "112233",
    "11223344",
    "12",
    "1209",
    "120gd43ac458",
    "1212",
    "121212",
    "12121212",
    "1213",
    "1214",
    "1217",
    "1225",
    "123",
    "`123",
    "123000",
    "123098",
    "123123",
    "123@123",
    "123123123",
    "12321",
    "123234",
    "123321",
    "1234",
    "12341234",
    "12345",
    "123456",
    "123456!",
    "1234567",
    "12345678",
    "123456789",
    "1234567890",
    "12345678910",
    "12345679",
    "1234567a",
    "123456a",
    "123456aa",
    "123456abc",
    "123456q",
    "12345qwert",
    "1234abc",
    "1234abcd",
    "1234qwer",
    "1234qwerty",
    "123654",
    "123654789",
    "123789",
    "123abc",
    "123.abc",
    "123@abc",
    "123admin",
    "123.com",
    "123go",
    "123hfjdk147",
    "123qwe",
    "123qwe!@#",
    "123qweasd",
    "123qweasdzxc",
    "123root",
    "123root123",
    "123www",
    "12qwaszx",
    "1313",
    "131313",
    "1314520",
    "1316",
    "1332",
    "13579",
    "1412",
    "1430",
    "14430",
    "145236",
    "147147",
    "159357",
    "159753",
    "1701d",
    "171717",
    "1812overture",
    "1818",
    "181818",
    "18atcskd2w",
    "1900",
    "1901",
    "1902",
    "1903",
    "1904",
    "1905",
    "1906",
    "1907",
    "1908",
    "1909",
    "1910",
    "1911",
    "1912",
    "1913",
    "1914",
    "1915",
    "1916",
    "1917",
    "1918",
    "1919",
    "1920",
    "1921",
    "1922",
    "1923",
    "1924",
    "1925",
    "1926",
    "1927",
    "1928",
    "1929",
    "1930",
    "1931",
    "1932",
    "1933",
    "1934",
    "1935",
    "1936",
    "1937",
    "1938",
    "1939",
    "1940",
    "1941",
    "1942",
    "1943",
    "1944",
    "1945",
    "1946",
    "1947",
    "1948",
    "1949",
    "1950",
    "1951",
    "1952",
    "1953",
    "1954",
    "1955",
    "1956",
    "1957",
    "1958",
    "1959",
    "1960",
    "1961",
    "1962",
    "1963",
    "1964",
    "1965",
    "1966",
    "1967",
    "1968",
    "1969",
    "1970",
    "1971",
    "1972",
    "1973",
    "1974",
    "1975",
    "1976",
    "1977",
    "1978",
    "1979",
    "1980",
    "1981",
    "1982",
    "1983",
    "1984",
    "1985",
    "1986",
    "1987",
    "1988",
    "1989",
    "1990",
    "1991",
    "1992",
    "1993",
    "1994",
    "1995",
    "1996",
    "1997",
    "1998",
    "1999",
    "1a2b3c",
    "1a2b3c4d",
    "1a2s3d4f",
    "1chris",
    "1kitty",
    "1l0v3y0u",
    "1p2o3i",
    "1q2w3e",
    "1q2w3e4r",
    "1q2w3e4r5t",
    "1q2w3e4r5t6y",
    "1q2w3e4r5t6y7u8i9o0p",
    "1qa2ws",
    "1qa2ws3ed",
    "1qaz",
    "1qaz2wsx",
    "1qaz2wsx3edc",
    "1qaz2wsx3edc4rfv",
    "1qaz#edc5tgb",
    "1qaz!qaz",
    "1qaz@wsx",
    "1qaz@wsx3edc$rfv",
    "1qazxsw@",
    "1qazxsw2",
    "1qw23e",
    "1qw23er4",
    "1qwe23",
    "1sanjose",
    "1thread2bill",
    "1z2x3c4v",
    "20",
    "2000",
    "2001",
    "2002",
    "2003",
    "2004",
    "2005",
    "2006",
    "2007",
    "2008",
    "2009",
    "2010",
    "2012",
    "2013",
    "2014",
    "2015",
    "2016",
    "2017",
    "2018",
    "2019",
    "2020",
    "2021",
    "2022",
    "2023",
    "2024",
    "2025",
    "2026",
    "2027",
    "2028",
    "2029",
    "2030",
    "2031",
    "2032",
    "2033",
    "2034",
    "2035",
    "2036",
    "2037",
    "2038",
    "21",
    "2112",
    "21122112",
    "22",
    "2200",
    "222",
    "2222",
    "22222",
    "222222",
    "2222222",
    "22222222",
    "2252",
    "225588",
    "232323",
    "24021988",
    "2bornot2b",
    "2h7vkzo266",
    "2kids",
    "2welcome",
    "2wsx",
    "2wsx3edc",
    "3",
    "3010",
    "3112",
    "31337",
    "31338",
    "3141",
    "3.1415",
    "31415926",
    "321",
    "321321",
    "321root",
    "321root321",
    "333",
    "3333",
    "33333",
    "333333",
    "3333333",
    "33333333",
    "3533",
    "369",
    "3bears",
    "3edc",
    "3edc4rfv5tgb",
    "3rjs1la7qe",
    "3@rth",
    "4",
    "4055",
    "4077mash",
    "42bsd",
    "4.2bsd",
    "4321",
    "43bsd",
    "4.3bsd",
    "444",
    "4444",
    "44444",
    "4444444",
    "44444444",
    "4788",
    "4854",
    "4dm1n",
    "4dm1n1str4t0r",
    "4na2xf",
    "4rfv",
    "4rfv$rfv",
    "4runner",
    "5",
    "5050",
    "5121",
    "520520",
    "521521",
    "5252",
    "54321",
    "555",
    "5555",
    "55555",
    "555555",
    "5555555",
    "55555555",
    "5683",
    "57chevy",
    "5amantha",
    "5and5",
    "5h3i5lik3p4rty@v3r",
    "5tgb",
    "5tgb6yhn",
    "5tgb6yhn#p",
    "6262",
    "6301",
    "654321",
    "666",
    "6666",
    "66666",
    "666666",
    "6666666",
    "66666666",
    "666s1czfarginn",
    "68jjj167@102",
    "6969",
    "696969",
    "69zulu4z",
    "6v21wbgad",
    "6yhn",
    "!7350r13r0",
    "741852",
    "753951",
    "7654321",
    "777",
    "7777",
    "77777",
    "777777",
    "7777777",
    "77777777",
    "789456",
    "789789",
    "7dwarfs",
    "7ujm",
    "7yhn",
    "80486",
    "852963",
    "8675309",
    "87654321",
    "888",
    "8888",
    "88888",
    "888888",
    "8888888",
    "88888888",
    "8ik,",
    "90210",
    "911",
    "911sc",
    "911scturbo",
    "911turbo",
    "92072",
    "963963",
    "987654",
    "987654321",
    "999",
    "9999",
    "99999",
    "999999",
    "9999999",
    "99999999",
    "a",
    "a111111",
    "a123123",
    "a12345",
    "a123456",
    "a123456789",
    "a159456",
    "a1b2c3",
    "a1b2c3d4",
    "a1s2d3",
    "a4576a",
    "aa",
    "aa123456",
    "aaa",
    "aaa123",
    "aaaa",
    "aaaaa",
    "aaaaaa",
    "aaaaaaa",
    "aaaaaaaa",
    "aardvark",
    "aaron",
    "aaron1",
    "aaron123",
    "aaronaaron",
    "aaronpass",
    "aarti",
    "ab1cd2ef3",
    "abacab",
    "abadabdoo",
    "abbot",
    "abbott",
    "abby",
    "abc",
    "abc123",
    "abc@123",
    "abc1234",
    "abc12345",
    "abc123456",
    "abcd",
    "abcd123",
    "abcd1234",
    "abcde",
    "abcdef",
    "abcdefg",
    "abcdefgh",
    "abcdefghi",
    "abdenace",
    "abdol",
    "abdul",
    "abdulkaf",
    "abdullah",
    "abdur",
    "abe",
    "abe123",
    "abel",
    "abel123",
    "abgrtyu",
    "abhijit",
    "abhiram",
    "abigail",
    "abigail123",
    "about",
    "abracadabra",
    "abracadaver",
    "abraham",
    "abraham123",
    "abrar",
    "absolut",
    "abuse",
    "abuse1",
    "abuse123",
    "abuseabuse",
    "abusepass",
    "acacia",
    "academia",
    "academic",
    "accept",
    "access",
    "accord",
    "account",
    "account123",
    "accounts",
    "accounts1",
    "accounts123",
    "accountsaccounts",
    "accountspass",
    "ace",
    "ace123",
    "acknak",
    "acropolis",
    "action",
    "actionman",
    "active",
    "actor",
    "acura",
    "ad4hosting",
    "ada",
    "ada123",
    "adabas",
    "adam",
    "adam1",
    "adam123",
    "adamadam",
    "adampass",
    "adams",
    "adel",
    "adela",
    "adela123",
    "adeline",
    "adeline123",
    "adg",
    "adgjmptw",
    "adi",
    "adib",
    "adidas",
    "adine",
    "adm",
    "adm123",
    "adm1234",
    "admin",
    "admin!@",
    "admin01",
    "admin1",
    "admin1111",
    "admin123",
    "admin@123",
    "admin1234",
    "admin12345",
    "admin123456",
    "adminadmin",
    "administ",
    "administrator",
    "administrator1",
    "administrator123",
    "adminlinux",
    "adminpass",
    "adminpassword",
    "adminroot",
    "admissions",
    "admissions1",
    "admissions123",
    "admissionsadmissions",
    "admissionspass",
    "adnan",
    "adobe1",
    "adobe123",
    "adobeadobe",
    "adolf",
    "adolf123",
    "adolph",
    "adolph123",
    "adrian",
    "adrian123",
    "adriana",
    "adriana123",
    "adrianna",
    "adrianne",
    "adrien",
    "adrienne",
    "adrock",
    "ads",
    "ads1",
    "ads123",
    "adsads",
    "adspass",
    "adult",
    "adventur",
    "advertise",
    "advertise1",
    "advertise123",
    "advertiseadvertise",
    "advertisepass",
    "advertising",
    "advertising1",
    "advertising123",
    "advertisingpass",
    "advil",
    "aeh",
    "aeneas",
    "aerobics",
    "affiliate",
    "affiliate1",
    "affiliate123",
    "affiliateaffiliate",
    "affiliatepass",
    "affiliates",
    "affiliates1",
    "affiliates123",
    "affiliatesaffiliates",
    "affiliatespass",
    "afresh",
    "africa",
    "africa123",
    "afrid",
    "after",
    "again",
    "agent",
    "aggie",
    "aggies",
    "agnes",
    "agnes123",
    "ahidee",
    "ahmed",
    "ahmet",
    "aikman",
    "aileen",
    "aimee",
    "airborne",
    "aircraft",
    "airhead",
    "airplane",
    "airwolf",
    "ajai",
    "ajay",
    "akhil",
    "aki123",
    "akiko",
    "al",
    "al123",
    "alain",
    "alamgir",
    "alan",
    "alan1",
    "alan123",
    "alanalan",
    "alanpass",
    "alas",
    "alaska",
    "alastair",
    "alayne",
    "albany",
    "albatros",
    "albatross",
    "albert",
    "albert123",
    "albertha",
    "albertha123",
    "alberto",
    "album",
    "alcapone",
    "alec",
    "alec123",
    "alejandr",
    "alena",
    "alert",
    "alessand",
    "alex",
    "alex1",
    "alex123",
    "alexalex",
    "alexande",
    "alexander",
    "alexander123",
    "alexandr",
    "alexandra",
    "alexandra123",
    "alexendr",
    "alexia",
    "alexis",
    "alexpass",
    "alf",
    "alfaro",
    "alfred",
    "alfred1",
    "alfred123",
    "algebra",
    "ali",
    "alias",
    "alias123",
    "aliases",
    "aliases1",
    "aliases123",
    "aliasesaliases",
    "aliasespass",
    "alica",
    "alice",
    "alice1",
    "alice123",
    "alicia",
    "alicia123",
    "alien",
    "aliens",
    "alina",
    "aline",
    "alisa",
    "alison",
    "alison123",
    "all",
    "allah",
    "allan",
    "allan123",
    "allegro",
    "allen",
    "alliance",
    "allison",
    "allo",
    "allstate",
    "aloha",
    "alok",
    "alpha",
    "alpha1",
    "alpha123",
    "alphabet",
    "alpine",
    "altaf",
    "altamira",
    "althea",
    "altima",
    "altima1",
    "alumni",
    "alumni1",
    "alumni123",
    "alva",
    "alvin",
    "alvin123",
    "always",
    "alyson",
    "alyssa",
    "am",
    "ama",
    "amadeus",
    "amalia",
    "amalia123",
    "amanda",
    "amanda1",
    "amanda123",
    "amandauser",
    "amar",
    "amarjit",
    "amarpree",
    "amateur",
    "amavis",
    "amavis123",
    "amazing",
    "amber",
    "amber123",
    "amelie",
    "america",
    "america7",
    "american",
    "american123",
    "ami",
    "amiga",
    "amorphous",
    "amos",
    "amour",
    "!@#$%^&amp;*()",
    "amril",
    "amy",
    "amy1",
    "amy123",
    "amyamy",
    "amypass",
    "an",
    "an1m@lpl@n3t",
    "ana",
    "anaconda",
    "anal",
    "analog",
    "analog1",
    "analog123",
    "analoganalog",
    "analogpass",
    "anant",
    "ananth",
    "anastacia",
    "anastacia123",
    "anastasi",
    "anchana",
    "anchor",
    "and",
    "anders",
    "anderson",
    "anderson123",
    "andi",
    "andra",
    "andra123",
    "andre",
    "andre1",
    "andrea",
    "andrea1",
    "andrea123",
    "andreaandrea",
    "andreapass",
    "andreas",
    "andreea",
    "andreea123",
    "andrew",
    "andrew!",
    "andrew1",
    "andrew123",
    "andrewandrew",
    "andrewpass",
    "android",
    "andromache",
    "andromada",
    "andromed",
    "andrzej",
    "andy",
    "andy1",
    "andy123",
    "andyandy",
    "andypass",
    "aneliese",
    "anewpass",
    "angel",
    "angel1",
    "angel123",
    "angela",
    "angela1",
    "angela123",
    "angelika",
    "angelina",
    "angelina123",
    "angelo",
    "angelo123",
    "angelofdeath",
    "angels",
    "angerine",
    "angie",
    "angie1",
    "angie123",
    "angry",
    "angus",
    "ani",
    "anil",
    "animal",
    "animalhouse",
    "animal house",
    "animals",
    "anis",
    "anita",
    "anjana",
    "anjen",
    "an-jen",
    "ann",
    "ann1",
    "ann123",
    "anna",
    "anna123",
    "annalena",
    "annalise",
    "annamari",
    "annann",
    "anne",
    "anne123",
    "anneli",
    "annette",
    "anni",
    "annie",
    "annie123",
    "announce",
    "announce1",
    "announce123",
    "announceannounce",
    "announcepass",
    "annpass",
    "anon",
    "anonftp",
    "anonftp1",
    "anonftp123",
    "anonftpanonftp",
    "anonftppass",
    "anonymous",
    "anonymous1",
    "anonymous123",
    "anonymousanonymous",
    "anonymouspass",
    "answer",
    "antares",
    "anthony",
    "anthony1",
    "anthony123",
    "anthonyanthony",
    "anthonypass",
    "anthropogenic",
    "antoine",
    "anton",
    "antonio",
    "antony",
    "antony123",
    "anu",
    "anumber1",
    "anumberone",
    "anupa",
    "anupam",
    "anurag",
    "anvils",
    "any",
    "anything",
    "anything1",
    "anything123",
    "anythinganything",
    "anythingpass",
    "ap0ll0",
    "apache",
    "apache1",
    "apache123",
    "apache2",
    "apacheapache",
    "apachepass",
    "apacheserver",
    "apl",
    "apollo",
    "apollo13",
    "apple",
    "apple1",
    "apple2",
    "appleii",
    "applepie",
    "apples",
    "april",
    "april123",
    "aptiva",
    "aq1sw2de3",
    "aqswde",
    "aqua",
    "aquarious",
    "aquarius",
    "aragorn",
    "aram",
    "arash",
    "arbenz",
    "archie",
    "architect",
    "arctic",
    "ardent",
    "are",
    "arelene",
    "ari",
    "aria",
    "ariadne",
    "ariane",
    "ariel",
    "ariella",
    "arif",
    "arijit",
    "arindam",
    "aristotle",
    "arizona",
    "arjun",
    "arjunasa",
    "arlene",
    "arm13!_a",
    "armand",
    "armando",
    "armen",
    "armond",
    "arnold",
    "arnold123",
    "aron",
    "around",
    "arrow",
    "arsenal",
    "arshad",
    "art",
    "art1",
    "art123",
    "artart",
    "artemis",
    "arthur",
    "arthur123",
    "articles",
    "articles1",
    "articles123",
    "articlesarticles",
    "articlespass",
    "artie",
    "artificial",
    "artist",
    "artpass",
    "arty",
    "arun",
    "aruna",
    "arvind",
    "as",
    "asad",
    "asap",
    "asd",
    "asd123",
    "asdasd",
    "asdf",
    "asdf123",
    "asdf1234",
    "asdfasdf",
    "asdfg",
    "asdfgh",
    "asdfghj",
    "asdfghjk",
    "asdfghjkl",
    "asdfghjkl;'",
    "asdfjkl",
    "asdfjkl;",
    "asdf;lkj",
    "asdlkj",
    "asdqwe123",
    "asdzxc",
    "ashima",
    "ashish",
    "ashley",
    "ashley1",
    "ashok",
    "ashraf",
    "ashton",
    "ashton123",
    "ashutosh",
    "asia",
    "asian",
    "asjeet",
    "ask",
    "aslkdfjh",
    "aslpls",
    "aslpls123",
    "asm",
    "aspen",
    "ass",
    "asshole",
    "assmunch",
    "asterisk",
    "asterix",
    "asterix123",
    "at",
    "atandt",
    "ate",
    "atena",
    "ath",
    "athanass",
    "athena",
    "athens",
    "athos1975",
    "atkh4atkm",
    "atlanta",
    "atmosphere",
    "atse",
    "at&t",
    "attila",
    "atul",
    "audie",
    "audio",
    "audra",
    "audrey",
    "august",
    "augusta",
    "augustin",
    "aurelius",
    "austin",
    "auth",
    "author",
    "author1",
    "author123",
    "authorauthor",
    "authorpass",
    "autumn",
    "avalon",
    "avatar",
    "avenger",
    "avenir",
    "avg",
    "avg123",
    "avi",
    "avni",
    "avraham",
    "away",
    "away!",
    "awesome",
    "axel",
    "axgt14ie",
    "ayelet",
    "aylmer",
    "azam",
    "azerty",
    "aziz",
    "azizi",
    "azsxdcfv",
    "azsxdcfvgb",
    "aztecs",
    "azure",
    "azure123",
    "b4ckm3upsc077y",
    "babak",
    "babe",
    "babes",
    "babies",
    "baby",
    "babydoll",
    "babylon5",
    "bacchus",
    "bach",
    "backdoor",
    "backrub",
    "backup",
    "backup123",
    "backuppc",
    "badass",
    "badboy",
    "badger",
    "badtimes",
    "baglady",
    "bagwoman",
    "bahram",
    "bailey",
    "bakedpotatoe",
    "baker",
    "bakshi",
    "balakris",
    "balas",
    "balasubr",
    "baldo",
    "baldwin",
    "balkrish",
    "ballard",
    "balls",
    "bambi",
    "bamboo",
    "ban",
    "banana",
    "bananas",
    "banane",
    "bancroft",
    "bandit",
    "bane",
    "bang",
    "banks",
    "banzai",
    "baptist",
    "baraka",
    "barb",
    "barbara",
    "barber",
    "barbie",
    "barf",
    "barfer",
    "barfing",
    "baritone",
    "barn",
    "barnes",
    "barney",
    "barney1",
    "barnie",
    "barnyard",
    "baron",
    "baronharkonnen",
    "baron harkonnen",
    "barret",
    "barrett",
    "barry",
    "barry1",
    "barry123",
    "barrybarry",
    "barrypass",
    "bart",
    "bartman",
    "barton",
    "bascketball",
    "basebal",
    "baseball",
    "basf",
    "basful",
    "bash",
    "basic",
    "basil",
    "baskar",
    "basket",
    "basketb",
    "basketba",
    "basketball",
    "bass",
    "bassoon",
    "bastard",
    "basuki",
    "batcave",
    "batch",
    "batcomputer",
    "bathory",
    "batman",
    "batman1",
    "batmobile",
    "bauer",
    "baystate",
    "b@b3",
    "bball",
    "bbb",
    "bbbb",
    "bbbbb",
    "bbbbbb",
    "bbbbbbb",
    "bbbbbbbb",
    "b@by",
    "bca6hf7q",
    "bchavez",
    "be",
    "bea",
    "beach",
    "beaches",
    "beagle",
    "beammeup",
    "beaner",
    "beanie",
    "beans",
    "bear",
    "bears",
    "beast",
    "beasty",
    "beater",
    "beatit",
    "beatles",
    "beatrice",
    "beautifu",
    "beautiful",
    "beauty",
    "beaver",
    "beavis",
    "beavis1",
    "beavis&amp;buthead",
    "beavisandbuthead",
    "bebe",
    "because",
    "becca",
    "becky",
    "beef",
    "been",
    "beer",
    "beethoven",
    "before",
    "behnam",
    "belgium",
    "belize",
    "bell",
    "bella",
    "belle",
    "bellow",
    "belmont",
    "beloved",
    "ben",
    "ben1",
    "ben123",
    "benben",
    "bengt",
    "benjamin",
    "benji",
    "bennet",
    "bennett",
    "benny",
    "benoit",
    "benpass",
    "benson",
    "bent",
    "beny",
    "benz",
    "beowulf",
    "beppe",
    "beresfor",
    "berhanu",
    "berkeley",
    "berlin",
    "berliner",
    "berlinwall",
    "bernard",
    "bernardo",
    "bernd",
    "bernhard",
    "bernie",
    "berry",
    "bert",
    "bert1",
    "bert123",
    "bertbert",
    "bertha",
    "bertpass",
    "beryl",
    "best",
    "beta",
    "beta123",
    "betacam",
    "beth",
    "bethany",
    "betsie",
    "betsy",
    "better",
    "bettie",
    "betty",
    "betty1",
    "betty123",
    "bettybetty",
    "bettypass",
    "bev",
    "bev1",
    "bev123",
    "bevbev",
    "beverly",
    "bevpass",
    "bfd",
    "bfi",
    "bharat",
    "bhavani",
    "bhoothap",
    "bhunjimkolp",
    "biay",
    "bicameral",
    "bichnga",
    "bichon",
    "bienveni",
    "big",
    "bigal",
    "bigband",
    "bigben",
    "bigbird",
    "bigboss",
    "bigboy",
    "bigbrother",
    "bigbucks",
    "bigcock",
    "bigcocks",
    "bigdeal",
    "bigdog",
    "bigdude",
    "bigfoot",
    "biggles",
    "bigguy",
    "bighips",
    "bighouse",
    "bigjoke",
    "bigmac",
    "bigman",
    "bigmouth",
    "bigred",
    "bigroom",
    "bigsecret",
    "bigtits",
    "bigtoe",
    "biker",
    "bilbo",
    "biliamee",
    "bill",
    "bill1",
    "bill123",
    "billbill",
    "billc",
    "billie",
    "billing",
    "billing1",
    "billing123",
    "billingbilling",
    "billingpass",
    "billpass",
    "bills",
    "billy",
    "billy1",
    "bim",
    "bimbo",
    "bimboe",
    "bimmer",
    "bin",
    "bin123",
    "bind",
    "bind1",
    "bind123",
    "bindbind",
    "bindpass",
    "bing",
    "bingo",
    "binky",
    "binod",
    "bioboy",
    "biochem",
    "biology",
    "bios",
    "bird",
    "bird33",
    "birdie",
    "birdy",
    "birget",
    "birgetta",
    "birgit",
    "birthday",
    "biscuit",
    "bishop",
    "bismillah",
    "bitch",
    "bitchin",
    "bitchin'",
    "bitching",
    "biteme",
    "bitter",
    "biz",
    "bizdev",
    "bizdev1",
    "bizdev123",
    "bizdevbizdev",
    "bizdevpass",
    "bizhan",
    "bjorn",
    "black",
    "black123",
    "blackboot",
    "blackie",
    "blackjack",
    "bladerunner",
    "blah",
    "blahblah",
    "blaine",
    "blair",
    "blake",
    "blanche",
    "blank",
    "blaster",
    "blazer",
    "bleep",
    "bleeping",
    "bleeps",
    "blinds",
    "bliss",
    "blitz",
    "blizzard",
    "blog",
    "blonde",
    "blondie",
    "blonds",
    "blonds1",
    "blood",
    "bloomcounty",
    "blow",
    "blowfish",
    "blowjob",
    "blowme",
    "blowoff",
    "blss",
    "blu3j3@ns",
    "blue",
    "blue123",
    "bluebird",
    "blueblazer",
    "blueeyes",
    "bluefish",
    "bluejean",
    "bluejeans",
    "blueline",
    "blues",
    "bluesky",
    "bluetooth",
    "bluevelvet",
    "bmw",
    "bnc",
    "bo",
    "board",
    "boat",
    "bob",
    "bob1",
    "bob123",
    "bob132",
    "bobbi",
    "bobbijo",
    "bobbob",
    "bobby",
    "bobcat",
    "bobpass",
    "bodyshop",
    "boeing",
    "bogart",
    "bogdan",
    "bogey",
    "bogus",
    "boleslaw",
    "bombay",
    "bond",
    "bond007",
    "boner",
    "bong",
    "bonita",
    "bonjour",
    "bonkers",
    "bonn",
    "bonnie",
    "bonnie1",
    "bonnie123",
    "bonniebonnie",
    "bonniepass",
    "bonsai",
    "bonzai",
    "bonzo",
    "boobie",
    "boobies",
    "booboo",
    "boobys",
    "booger",
    "boogie",
    "book",
    "bookem",
    "bookemdanno",
    "booking",
    "booking1",
    "booking123",
    "bookingbooking",
    "bookingpass",
    "bookit",
    "boomer",
    "boon",
    "booster",
    "boots",
    "bootsie",
    "boozie",
    "bor",
    "boris",
    "bornagai",
    "bosco",
    "boss",
    "bosto",
    "bostoaca",
    "bostocel",
    "boston",
    "both",
    "boulder",
    "bouncer",
    "bourbon",
    "bourne",
    "bourneagain",
    "bourne-again",
    "bowling",
    "box",
    "boxer",
    "boxers",
    "boxoffice",
    "boxoffice1",
    "boxoffice123",
    "boxofficeboxoffice",
    "boxofficepass",
    "boyd",
    "boywonder",
    "bozo",
    "br549admin",
    "brad",
    "brad1",
    "brad123",
    "bradbrad",
    "bradford",
    "bradjanet",
    "brad&janet",
    "bradley",
    "bradnjanet",
    "bradpass",
    "brain",
    "braindead",
    "branch",
    "brandi",
    "brand-n-janet",
    "brandon",
    "brandy",
    "branisla",
    "brasil",
    "brat",
    "bravenewworld",
    "braves",
    "brazil",
    "breakout",
    "breast",
    "breastfeed",
    "breasts",
    "brenda",
    "brendan",
    "brenden",
    "brent",
    "brent1",
    "brent123",
    "brentbrent",
    "brentpass",
    "bret",
    "breton",
    "brett",
    "brewster",
    "brian",
    "brian1",
    "brian123",
    "briana",
    "brianbrian",
    "brianpass",
    "brickles",
    "brickout",
    "bridge",
    "bridges",
    "bridget",
    "bridgett",
    "briefcase",
    "bright",
    "bring",
    "brinkley",
    "britain",
    "britney",
    "broadway",
    "brokenheart",
    "broker",
    "bromberg",
    "bronco",
    "broncos",
    "bronte",
    "brooke",
    "brooklyn",
    "brooks",
    "brothel",
    "brother",
    "brothers",
    "brown",
    "brown123",
    "browns",
    "bruce",
    "bruce1",
    "bruce123",
    "brucebruce",
    "brucepass",
    "bruno",
    "brutus",
    "bryan",
    "bryant",
    "bryce",
    "bryn",
    "bsd",
    "bsd4",
    "bsdunix",
    "bubba",
    "bubba1",
    "bubbah",
    "bubbahlah",
    "bubbalah",
    "bubble",
    "bubbles",
    "buck",
    "buckaroo",
    "bucks",
    "bud",
    "budd",
    "buddah",
    "buddha",
    "buddhist",
    "buddy",
    "budgie",
    "budlite",
    "buffalo",
    "buffett",
    "buffy",
    "bugs",
    "bugsbunny",
    "bugsy",
    "buid123",
    "build",
    "bull",
    "bulldog",
    "bullet",
    "bulls",
    "bullshit",
    "bumbling",
    "bung",
    "bunny",
    "bunnyrabbit",
    "burgess",
    "burke",
    "burns",
    "burt",
    "burton",
    "busalacc",
    "business",
    "business1",
    "business123",
    "businessbusiness",
    "businesspass",
    "buster",
    "but",
    "butch",
    "butler",
    "butt",
    "butter",
    "butterfly",
    "buttfuck",
    "buttfucker",
    "butthead",
    "button",
    "buttons",
    "buy",
    "buzz",
    "by",
    "byoung",
    "byoungin",
    "byron",
    "byteme",
    "bytes",
    "byung",
    "c",
    "c++",
    "c00per",
    "c3po",
    "cabernet",
    "cabinboy",
    "cache",
    "cache1",
    "cache123",
    "cachecache",
    "cachepass",
    "cactus",
    "cad",
    "cadat",
    "cadcam",
    "cadweld",
    "caesar",
    "caip",
    "caipcad",
    "caitlen",
    "caitlin",
    "cal",
    "caleb",
    "calendar",
    "calgary",
    "caliban",
    "californ",
    "california",
    "call",
    "caltech",
    "calvin",
    "calvin1",
    "camaro",
    "camay",
    "camel",
    "camelia",
    "camellia",
    "camera",
    "cameron",
    "camilla",
    "camille",
    "camlin",
    "campanile",
    "campbell",
    "camping",
    "can",
    "canada",
    "canced",
    "cancer",
    "candace",
    "candi",
    "candy",
    "canela",
    "canna",
    "canna123",
    "cannon",
    "cannonda",
    "cannondale",
    "canon",
    "cantor",
    "canucks",
    "canute",
    "cap",
    "capfast",
    "captain",
    "captain1",
    "captain123",
    "captaincaptain",
    "captainpass",
    "captian",
    "car",
    "carbon",
    "card",
    "cardinal",
    "carebear",
    "careers",
    "careers1",
    "careers123",
    "careerscareers",
    "careerspass",
    "caren",
    "carey",
    "carina",
    "carl",
    "carla",
    "carlena",
    "carlo",
    "carlos",
    "carlton",
    "carlyle",
    "carlyn",
    "carmella",
    "carmen",
    "carnage",
    "carol",
    "carol1",
    "carol123",
    "carolcarol",
    "carole",
    "caroleen",
    "carolie",
    "carolina",
    "caroline",
    "carolpass",
    "carolyn",
    "carrie",
    "carrol",
    "carrot",
    "carry",
    "carson",
    "carsten",
    "cart00n",
    "cart00ns",
    "carter",
    "carter15",
    "cartman",
    "cartoon",
    "cartoons",
    "carver",
    "cary",
    "caryl",
    "caryn",
    "casa",
    "cascade",
    "cascades",
    "casey",
    "cash",
    "cashbox",
    "cashier",
    "cashier1",
    "cashier123",
    "cashiercashier",
    "cashierpass",
    "casio",
    "caspar",
    "casper",
    "cassandra",
    "cassie",
    "castle",
    "cat",
    "catalina",
    "catalog",
    "catch22",
    "catfish",
    "catherin",
    "catherine",
    "cathi",
    "cathleen",
    "cathy",
    "cathy1",
    "cathy123",
    "cathycathy",
    "cathypass",
    "catnip",
    "cats",
    "catwoman",
    "cayuga",
    "cbet1026",
    "ccc",
    "cccc",
    "ccccc",
    "cccccc",
    "ccccccc",
    "cccccccc",
    "cecil",
    "cecile",
    "cecilia",
    "cecily",
    "cedic",
    "cedric",
    "celeste",
    "celia",
    "celica",
    "celine",
    "celtics",
    "cement",
    "center",
    "centos",
    "ceo",
    "ceo1",
    "ceo123",
    "ceoceo",
    "ceopass",
    "cerebus",
    "cerulean",
    "cesar",
    "cesare",
    "cessna",
    "cezar",
    "cfi",
    "cfj",
    "cgi",
    "cgi1",
    "cgi123",
    "cgicgi",
    "cgipass",
    "cgj",
    "ch",
    "chad",
    "chai",
    "chain",
    "chainsaw",
    "chakkala",
    "challeng",
    "challenge",
    "chameleon",
    "champion",
    "champs",
    "chan",
    "chance",
    "chand",
    "chandimal",
    "chandler",
    "chandra",
    "chandram",
    "chandras",
    "chanel",
    "chanequa",
    "chang",
    "chang3m3",
    "change",
    "changed",
    "changeit",
    "changeme",
    "changeme123",
    "changeme_123",
    "changethis",
    "changho",
    "changkyu",
    "channel",
    "channi",
    "chanshin",
    "chantal",
    "chao",
    "chaofeng",
    "chaos",
    "chao-yan",
    "chapman",
    "chardonnay",
    "charger",
    "charity",
    "charles",
    "charles1",
    "charles123",
    "charlescharles",
    "charlespass",
    "charlie",
    "charlie1",
    "charlott",
    "charlotte",
    "charming",
    "charon",
    "chas",
    "chase",
    "chat",
    "chau",
    "checkin",
    "checkov",
    "chedsada",
    "cheese",
    "cheesecake",
    "cheif",
    "chelsea",
    "chelsea1",
    "chem",
    "chemistry",
    "chen",
    "cheng",
    "cheow",
    "cheow-to",
    "cher",
    "cherala",
    "cherry",
    "cheryl",
    "cheryl1",
    "cheryl123",
    "cherylcheryl",
    "cherylpass",
    "chess",
    "chester",
    "chester1",
    "cheung",
    "chevy",
    "chevy1",
    "chi",
    "chia",
    "chia-hua",
    "chia-lin",
    "chiara",
    "chia-yin",
    "chia-yu",
    "chicago",
    "chicken",
    "chico",
    "chiefs",
    "chien",
    "chihsing",
    "childsplay",
    "chile",
    "chilin",
    "chin",
    "china",
    "chinacat",
    "ching",
    "ching-en",
    "ching-li",
    "ching-me",
    "chinook",
    "chinpan",
    "chin-w",
    "chip",
    "chi-pang",
    "chipper",
    "chiquita",
    "chisheng",
    "chi-shun",
    "chi-tai",
    "chi-wang",
    "chi-yao",
    "chldrn",
    "chloe",
    "cho",
    "choco",
    "chocolat",
    "chocolate",
    "chol",
    "choong",
    "choong-h",
    "chop",
    "chopsticks",
    "chorist",
    "chou",
    "chouette",
    "chris",
    "chris1",
    "chris123",
    "chrischris",
    "chrispass",
    "chrispen",
    "chriss",
    "chrissie",
    "chrissy",
    "christ",
    "christ1",
    "christa",
    "christia",
    "christian",
    "christie",
    "christin",
    "christina",
    "christine",
    "christmas",
    "christop",
    "christoph",
    "christopher",
    "christy",
    "chronos",
    "chu",
    "chuck",
    "chuck1",
    "chuck123",
    "chuckchuck",
    "chuckpass",
    "chucky",
    "chuen-ch",
    "chuen-ts",
    "chun",
    "chung",
    "chungen",
    "chung-na",
    "chung-pi",
    "chung-ya",
    "chungyen",
    "chun-lin",
    "chun-she",
    "chun-yu",
    "chuong",
    "church",
    "churn-hu",
    "cic",
    "cicciabuatta1",
    "cicero",
    "cigar",
    "cimarron",
    "cindelyn",
    "cinder",
    "cindi",
    "cindy",
    "cindy1",
    "cindy123",
    "cinema",
    "circuit",
    "circulation",
    "circulation1",
    "circulation123",
    "circulationpass",
    "cirque",
    "cirrus",
    "cisco",
    "cisco123",
    "civic",
    "civil",
    "claire",
    "clamav",
    "clamav123",
    "clambake",
    "clancy",
    "clapton",
    "clara",
    "clare",
    "clarence",
    "clarisa",
    "clarissa",
    "clark",
    "clarkson",
    "class",
    "class123",
    "class2004",
    "class2005",
    "classic",
    "classifieds",
    "classifieds1",
    "classifieds123",
    "classifiedspass",
    "classroo",
    "classroom",
    "claude",
    "claudel",
    "claudia",
    "claudiu",
    "cleaner",
    "cleanfight",
    "cleanroom",
    "cleat",
    "cleavage",
    "cleo",
    "client",
    "client1",
    "cliff",
    "clifford",
    "clifton",
    "clinic",
    "clint",
    "clinton",
    "clipper",
    "clit",
    "clitoris",
    "clock",
    "cloclo",
    "closas",
    "close",
    "closefriend",
    "cloud",
    "clover",
    "clueless",
    "cluster",
    "clusters",
    "coatamundi",
    "coatimundi",
    "cobain",
    "cobra",
    "cocacola",
    "cocakola",
    "cock",
    "coco",
    "code",
    "codename",
    "coder",
    "cody",
    "coe",
    "coffee",
    "cohen",
    "cokacola",
    "coke",
    "cokeisit",
    "colby",
    "cold",
    "coldcuts",
    "coldshoulder",
    "coldwar",
    "cole",
    "coleen",
    "coleman",
    "colette",
    "colin",
    "colleen",
    "college",
    "collette",
    "collin",
    "collins",
    "color",
    "colorado",
    "colors",
    "colour",
    "colt45",
    "coltrane",
    "columbia",
    "com",
    "com123",
    "comandur",
    "combination",
    "come",
    "comedienne",
    "comeon",
    "comeonletmein",
    "comercial",
    "comet",
    "commander",
    "comments",
    "comments1",
    "comments123",
    "commentscomments",
    "commentspass",
    "commrades",
    "communication",
    "community",
    "community1",
    "community123",
    "communitycommunity",
    "communitypass",
    "compact",
    "compaq",
    "compileuser",
    "compton",
    "compuserve",
    "compute",
    "computer",
    "comrade",
    "comrades",
    "concept",
    "concorde",
    "condo",
    "condom",
    "condoms",
    "confession",
    "confiden",
    "configurewithoutx",
    "confixx",
    "confused",
    "connect",
    "conner",
    "connie",
    "connor",
    "conrad",
    "console",
    "conspiritu",
    "consulta",
    "consulti",
    "consulting",
    "consulting1",
    "consulting123",
    "consultingconsulting",
    "consultingpass",
    "contact",
    "contact1",
    "contact123",
    "contactcontact",
    "contactpass",
    "contactus",
    "contactus1",
    "contactus123",
    "contactuscontactus",
    "contactuspass",
    "content",
    "content1",
    "content123",
    "contentcontent",
    "contentpass",
    "control",
    "conversion",
    "convex",
    "cook",
    "cookie",
    "cookies",
    "cooking",
    "cool",
    "coolbean",
    "coolman",
    "cooper",
    "cooter",
    "copier",
    "copper",
    "copyright",
    "copyright1",
    "copyright123",
    "copyrightcopyright",
    "copyrightpass",
    "cora",
    "coralyn",
    "cordelia",
    "core",
    "corey",
    "corine",
    "corinna",
    "corinne",
    "corky",
    "corlene",
    "cornelia",
    "cornelius",
    "cornflake",
    "corona",
    "corrado",
    "correct horse battery staple",
    "corrie",
    "corrina",
    "corvette",
    "corwin",
    "cosmic",
    "cosmo",
    "cosmos",
    "cougar",
    "cougars",
    "could",
    "country",
    "couples",
    "courier",
    "courtney",
    "couscous",
    "coventry",
    "cowboy",
    "cowboys",
    "cows",
    "cox",
    "coyote",
    "cpanel",
    "cpanel123",
    "crack1",
    "cracker",
    "craig",
    "craig1",
    "craig123",
    "craigcraig",
    "craigh",
    "craigpass",
    "crapp",
    "craps",
    "crashcourse",
    "crawford",
    "crazy4host",
    "crazyvps",
    "crazyvps1",
    "crazyvps2",
    "create",
    "creation",
    "creative",
    "credit",
    "creosote",
    "crescent",
    "cretin",
    "crew",
    "cricket",
    "criminal",
    "crimson",
    "crimson123",
    "cristina",
    "cristina123",
    "cronus",
    "cross",
    "crow",
    "crowley",
    "crug",
    "cruise",
    "crusader",
    "crystal",
    "cs",
    "cs1",
    "cs123",
    "csc298",
    "csc412",
    "cscie-ci",
    "cscs",
    "csee",
    "cs-ee",
    "cshrc",
    "cspass",
    "@ct10n",
    "cthreepo",
    "cthulhu",
    "cucemosu",
    "cuda",
    "cuddles",
    "cuervo",
    "cum",
    "cunningham",
    "cunt",
    "cuong",
    "cupcake",
    "curator",
    "curator1",
    "curator123",
    "curatorcurator",
    "curatorpass",
    "curmudgeon",
    "current",
    "curt",
    "curtis",
    "custom",
    "custom1",
    "custom123",
    "customcustom",
    "customer",
    "customer1",
    "customer123",
    "customercare",
    "customercare1",
    "customercare123",
    "customercarepass",
    "customercustomer",
    "customerpass",
    "customerservice",
    "customerservice1",
    "customerservice123",
    "customerservicepass",
    "customersupport",
    "customersupport1",
    "customersupport123",
    "customersupportpass",
    "custompass",
    "custserv",
    "custserv1",
    "custserv123",
    "custservcustserv",
    "custservpass",
    "custsup",
    "cut",
    "cutdown",
    "cutie",
    "cutiepie",
    "cutlass",
    "cvs",
    "cvs1",
    "cvs123",
    "cvscvs",
    "cvspass",
    "cvsroot",
    "cvsroot123",
    "cvsuser",
    "cvsuser1",
    "cvsuser123",
    "cyan",
    "cyan123",
    "cyber",
    "cyberpunk",
    "cyclone",
    "cyndi",
    "cynthia",
    "cyrano",
    "cyril",
    "cyrus",
    "cyrus123",
    "d1lakiss",
    "d1sc0v3ry",
    "d3b14n",
    "@d4h0st",
    "daddy",
    "daebum",
    "daedalus",
    "daehyun",
    "daemon",
    "daemon123",
    "daemonic",
    "daemons",
    "dagger",
    "dagger1",
    "daily",
    "dain",
    "daisie",
    "daisy",
    "dakota",
    "dale",
    "dalia",
    "dalibor",
    "dalit",
    "dallas",
    "daltry",
    "dalu",
    "dame",
    "damian",
    "damien",
    "dammit",
    "damogran",
    "damon",
    "damrongs",
    "dan",
    "dan1",
    "dan123",
    "dana",
    "dance",
    "dance1",
    "dance123",
    "dancedance",
    "dancepass",
    "dancer",
    "dandan",
    "dane",
    "dangermouse",
    "danh",
    "daniel",
    "daniel1",
    "daniel123",
    "daniela",
    "danieldaniel",
    "daniele",
    "danielle",
    "danielpass",
    "dank",
    "danna",
    "danni",
    "danny",
    "danpass",
    "dante",
    "daphne",
    "dapper",
    "daqing",
    "darcy",
    "daren",
    "darian",
    "darin",
    "dario",
    "darius",
    "dark",
    "dark1",
    "dark123",
    "darkblue",
    "darkman",
    "darkstar",
    "darla",
    "darrell",
    "darren",
    "darrin",
    "darrow",
    "darryl",
    "darth",
    "darthvader",
    "darwei",
    "darwin",
    "daryl",
    "daryouch",
    "dasha",
    "dasusr",
    "dasusr1",
    "dasusr123",
    "dat",
    "data",
    "data1",
    "database",
    "datatrain",
    "date",
    "datoo",
    "dave",
    "dave1",
    "dave123",
    "davedave",
    "davepass",
    "david",
    "david1",
    "david123",
    "daviddavid",
    "davidovi",
    "davidpass",
    "davids",
    "davis",
    "davy",
    "dawit",
    "dawn",
    "dax",
    "day",
    "daylight",
    "daytek",
    "db4web",
    "dbadmin",
    "dbadmin123",
    "ddanielrod",
    "dday",
    "ddd",
    "dddd",
    "ddddd",
    "dddddd",
    "ddddddd",
    "dddddddd",
    "de",
    "dead",
    "deadahead",
    "deadhead",
    "dead-head",
    "deadhed",
    "dean",
    "de'an",
    "dean1",
    "dean123",
    "deandean",
    "deanna",
    "deanpass",
    "death",
    "deathstar",
    "deb",
    "debasish",
    "debbie",
    "debby",
    "debian",
    "debian1",
    "debian123",
    "debiandebian",
    "debianpass",
    "deborah",
    "deborah1",
    "deborah123",
    "deborahdeborah",
    "deborahpass",
    "debra",
    "debug",
    "december",
    "decker",
    "dedhead",
    "dedhed",
    "dedi",
    "dedicated",
    "dee",
    "deedee",
    "deepak",
    "deepfreeze",
    "deepsea",
    "deepsix",
    "deepspace",
    "deepthroat",
    "deeznuts",
    "def",
    "default",
    "defense",
    "defoe",
    "dekai",
    "delano",
    "delete",
    "delia",
    "deliver",
    "delnaz",
    "delois",
    "delta",
    "delta123",
    "deluge",
    "demeter",
    "demo",
    "demo1",
    "demo123",
    "demon",
    "demonic",
    "demons",
    "denali",
    "denirulzz99",
    "denis",
    "denisa123",
    "denise",
    "dennis",
    "dennis123",
    "denny",
    "denver",
    "denys",
    "denzel",
    "depeche",
    "deposits",
    "deposits1",
    "deposits123",
    "depositsdeposits",
    "depositspass",
    "dept",
    "dequin",
    "der",
    "derek",
    "derluen",
    "derrek",
    "desaree",
    "desert",
    "design",
    "design1",
    "design123",
    "designdesign",
    "designpass",
    "desiree",
    "deskjet",
    "desktop",
    "desktop123",
    "desmond",
    "desperate",
    "destiny",
    "detleff",
    "detroit",
    "deutsch",
    "dev",
    "dev1",
    "dev123",
    "devadmin",
    "devdev",
    "develenv",
    "develenv1",
    "develenv123",
    "develenvdevelenv",
    "develenvpass",
    "develop",
    "developers",
    "developers1",
    "developers123",
    "developersdevelopers",
    "developerspass",
    "deven",
    "device",
    "devil",
    "devilinside",
    "devilsins",
    "devine",
    "/dev/null",
    "devon",
    "devpass",
    "dew",
    "dewayne",
    "dewey",
    "dewydecimal",
    "dexter",
    "dgj",
    "dhan",
    "dharma",
    "dharmara",
    "dhcp",
    "dhiraj",
    "diablo",
    "diag",
    "diags",
    "dial",
    "dialin",
    "dial-in",
    "dialup",
    "dial-up",
    "diamond",
    "diamonds",
    "dian",
    "diana",
    "diane",
    "diane1",
    "diane123",
    "dianediane",
    "dianepass",
    "diann",
    "dianne",
    "diaz",
    "dick",
    "dickens",
    "dickhead",
    "dicktracy",
    "did",
    "diego",
    "diesel",
    "diet",
    "dietcoke",
    "dieter",
    "digger",
    "digital",
    "digital1",
    "dilbert",
    "dilip",
    "dillweed",
    "dim",
    "dima",
    "dimension",
    "dimitris",
    "dimwit",
    "dina",
    "dinesh",
    "dinner",
    "dino",
    "dino1",
    "dinosaur",
    "dinozaur",
    "dipak",
    "diplomac",
    "diplomacy",
    "dipper",
    "dipstick",
    "dipta",
    "direct1",
    "director",
    "director1",
    "director123",
    "directordirector",
    "directorpass",
    "dirk",
    "disc",
    "discbrakes",
    "discjockey",
    "disco",
    "discovery",
    "discuss",
    "discuss1",
    "discuss123",
    "discussdiscuss",
    "discusspass",
    "disk",
    "diskquota",
    "diskquota1",
    "diskquota123",
    "diskquotadiskquota",
    "diskquotapass",
    "disney",
    "displays",
    "dixie",
    "dixon",
    "@dm1n",
    "dmrthazq",
    "do",
    "doan",
    "doareu",
    "doartu",
    "doc",
    "doctor",
    "document",
    "dodger",
    "dodgers",
    "does",
    "dog",
    "dogbert",
    "dogcatcher",
    "dogfight",
    "doggie",
    "doggy",
    "doit",
    "doitnow",
    "dollar",
    "dollars",
    "dolly",
    "dolores",
    "dolph",
    "dolphin",
    "dolphins",
    "domain",
    "domenico",
    "dominic",
    "dominick",
    "dominique",
    "domino",
    "don",
    "don1",
    "don123",
    "dona",
    "donald",
    "dondon",
    "done",
    "dong",
    "dongming",
    "donkey",
    "donn",
    "donna",
    "donna1",
    "donna123",
    "donnadonna",
    "donnapass",
    "donny",
    "donovan",
    "donpass",
    "don't",
    "dontknow",
    "doobie",
    "doodz",
    "doofus",
    "doogie",
    "dookie",
    "doom",
    "doom2",
    "doon",
    "doors",
    "dopey",
    "dora",
    "dorab",
    "dorai",
    "dorcas",
    "doreen",
    "dori",
    "dorian",
    "dorin",
    "dorine",
    "doris",
    "dorit",
    "dork",
    "dorms",
    "dorothea",
    "dorothy",
    "dos",
    "dot",
    "double",
    "doudou",
    "doug",
    "doug1",
    "doug123",
    "dougdoug",
    "dougie",
    "douglas",
    "dougpass",
    "dovecot",
    "dovecot123",
    "down",
    "download",
    "downloads",
    "downtown",
    "draft",
    "dragon",
    "dragon1",
    "dragonfl",
    "dragonfly",
    "dragons",
    "draw",
    "draxo",
    "drazen",
    "dr.demento",
    "dream",
    "dreambox",
    "dreamer",
    "dreamfish007",
    "dreams",
    "dreamscape",
    "dreamweaver",
    "drew",
    "drew1",
    "drew123",
    "drewdrew",
    "drewpass",
    "drillpress",
    "drink",
    "dripping",
    "driver",
    "drizzt",
    "drno",
    "droopy",
    "drop",
    "dropdead",
    "drop dead",
    "drought",
    "drugnig",
    "drugs",
    "drum",
    "drums",
    "drx6485",
    "dryden",
    "d!t",
    "d!t)tpw",
    "duane",
    "duck",
    "duckie",
    "ducksbreath",
    "ducksoup",
    "dude",
    "dudley",
    "duke",
    "dukeleto",
    "duke leto",
    "dulce",
    "dumbass",
    "dummy",
    "dummy123",
    "dunbar",
    "duncan",
    "dundee",
    "dune",
    "dungeons",
    "dunn",
    "duplicate",
    "dustin",
    "dusty",
    "dutch",
    "dutchess",
    "dvlinside",
    "dwain",
    "dwane",
    "dwayne",
    "dwight",
    "dylan",
    "dyndns",
    "e",
    "e5efehw65",
    "each",
    "eager",
    "eagle",
    "eagle1",
    "eagles",
    "earl",
    "earleen",
    "earnest",
    "earth",
    "easier",
    "easnetw0rk",
    "east",
    "easter",
    "eastern",
    "easton",
    "easy",
    "easycome",
    "easygo",
    "easylay",
    "eat",
    "eatme",
    "eatshit",
    "eatshitand",
    "eckart",
    "eclipse",
    "economist",
    "ed",
    "ed1",
    "ed123",
    "edc",
    "edcvfr",
    "eddie",
    "eddy",
    "edea",
    "edea1",
    "edea123",
    "edeaedea",
    "edeapass",
    "eded",
    "eden",
    "edgar",
    "edges",
    "edinburgh",
    "edison",
    "edith",
    "editing",
    "editor",
    "editor1",
    "editor123",
    "editoreditor",
    "editorpass",
    "editors",
    "editors1",
    "editors123",
    "editorseditors",
    "editorspass",
    "edmund",
    "edouard",
    "edpass",
    "edu",
    "eduard",
    "eduardo",
    "education",
    "edward",
    "edwards",
    "edwin",
    "edwina",
    "eecs",
    "ee-cs",
    "eee",
    "eeee",
    "eeeee",
    "eeeeee",
    "eeeeeee",
    "eeeeeeee",
    "eeyore",
    "effie",
    "egg",
    "eggdrop",
    "egghead",
    "eiderdown",
    "eieio",
    "eight",
    "eileen",
    "einstein",
    "eirik",
    "eka",
    "ekaterin",
    "ektuhi1234",
    "eladio",
    "elaine",
    "elanor",
    "eleanor",
    "electric",
    "element",
    "elena",
    "eleni",
    "elephant",
    "eli",
    "elias",
    "elijah",
    "elina1",
    "eliot",
    "eliott",
    "elisa",
    "elisabet",
    "elisabeth",
    "elissa",
    "eliza",
    "elizabet",
    "elizabeth",
    "elizabeth1",
    "elizabeth123",
    "elizabethelizabeth",
    "elizabethpass",
    "ella",
    "ellen",
    "ellie",
    "elliot",
    "elliott",
    "ellis",
    "elly",
    "elmer",
    "elmira",
    "elmo",
    "elmootaz",
    "elmstree",
    "eloise",
    "elsa",
    "elsie",
    "elton",
    "elvin",
    "elvira",
    "elvis",
    "elwood",
    "elwyn",
    "email",
    "e-mail",
    "email1",
    "email123",
    "emailemail",
    "emailpass",
    "emely",
    "emerald",
    "emerson",
    "emil",
    "emile",
    "emilio",
    "emily",
    "eminem",
    "emma",
    "emma123",
    "emmanuel",
    "emmi",
    "emmitt",
    "emmy",
    "emory",
    "empire",
    "employment",
    "employment1",
    "employment123",
    "employmentemployment",
    "employmentpass",
    "emptyhanded",
    "emptyheaded",
    "enda",
    "endah",
    "enemy",
    "energy",
    "engage",
    "engine",
    "engineer",
    "engineer123",
    "england",
    "enigma",
    "enquiries",
    "enquiries1",
    "enquiries123",
    "enquiriesenquiries",
    "enquiriespass",
    "enquiry",
    "enquiry1",
    "enquiry123",
    "enquiryenquiry",
    "enquirypass",
    "enrique",
    "enter",
    "enterprise",
    "entropy",
    "enzo",
    "enzyme",
    "eratea",
    "erenity",
    "erh",
    "erhard",
    "eric",
    "eric1",
    "eric123",
    "erica",
    "ericeric",
    "erich",
    "erick",
    "ericpass",
    "erik",
    "erika",
    "erin",
    "erling",
    "ernest",
    "ernesto",
    "ernie",
    "ernie1",
    "ernst",
    "erotic",
    "ersatz",
    "ertyuiop",
    "ervan",
    "eryn",
    "escape",
    "escort",
    "escort1",
    "esfandia",
    "esmond",
    "espanol",
    "establish",
    "estate",
    "estelle",
    "esther",
    "et",
    "etaoin",
    "etaoinshrdlu",
    "etaoin shrdlu",
    "etc",
    "/etc/passwd",
    "etee",
    "eternity",
    "ethan",
    "etoile",
    "eucc",
    "euclid",
    "eugen",
    "eugene",
    "eugenia",
    "eula",
    "eung",
    "eunji",
    "europe",
    "eustace",
    "eustaces",
    "ev1server",
    "eva",
    "evan",
    "evans",
    "eve",
    "evelina",
    "evelyn",
    "evelyne",
    "eventos",
    "events",
    "events1",
    "events123",
    "eventsevents",
    "eventspass",
    "everafter",
    "everett",
    "every",
    "evie",
    "exavier",
    "excaliber",
    "excalibu",
    "excalibur",
    "excel",
    "except",
    "exim",
    "exim123",
    "explore",
    "explorer",
    "exponent",
    "export",
    "express",
    "extension",
    "exxxtreme",
    "eyal",
    "f00km3",
    "f3d0ra",
    "fabian",
    "fabio",
    "fabrice",
    "face",
    "factoria",
    "faculty",
    "fagaras",
    "fail",
    "fairview",
    "fairway",
    "fairyring",
    "faith",
    "fake1234",
    "falcon",
    "falsestart",
    "family",
    "family1",
    "fanclub",
    "fanclub1",
    "fanclub123",
    "fanclubfanclub",
    "fanclubpass",
    "fancy",
    "fang",
    "faq",
    "faq1",
    "faq123",
    "faqfaq",
    "faqpass",
    "far",
    "far2hard",
    "farah",
    "faretheewell",
    "farflung",
    "fargone",
    "farhad",
    "farmer",
    "farming",
    "farout",
    "farrell",
    "farside",
    "faruk",
    "fasihudd",
    "fast",
    "fastbreak",
    "fastlane",
    "fataneh",
    "fatboy",
    "fatcat",
    "fathyzoo",
    "faust",
    "faye",
    "fayez",
    "fdsa",
    "fearless",
    "february",
    "fedora",
    "fedoracore",
    "feedback",
    "feedback1",
    "feedback123",
    "feedbackfeedback",
    "feedbackpass",
    "feedme",
    "felicia",
    "feliks",
    "felipe",
    "felix",
    "fender",
    "fenris",
    "ferdinand",
    "fereydoo",
    "fergus",
    "ferguson",
    "fermat",
    "ferrari",
    "ferret",
    "ferris",
    "fester",
    "festival",
    "fff",
    "ffff",
    "fffff",
    "ffffff",
    "fffffff",
    "ffffffff",
    "fft_dbkbb_020103",
    "fgh",
    "fiction",
    "fidel",
    "fidelity",
    "field",
    "figaro",
    "figleaf",
    "file",
    "files",
    "filesyst",
    "filip",
    "filippo",
    "finance",
    "financeiro",
    "find",
    "finder",
    "finite",
    "finn",
    "fiona",
    "fire",
    "fireball",
    "firebird",
    "fireman",
    "firenze",
    "firewalk",
    "firewall",
    "first",
    "fish",
    "fish1",
    "fisher",
    "fishers",
    "fishes",
    "fishhead",
    "fishie",
    "fishing",
    "fishing1",
    "fishing123",
    "fishingfishing",
    "fishingpass",
    "fist",
    "fitness",
    "fitz",
    "five",
    "flakes",
    "flamingo",
    "flanders",
    "flash",
    "flash123",
    "fld",
    "flea",
    "fleming",
    "fletch",
    "fletcher",
    "fleurs",
    "flight",
    "flip",
    "flipper",
    "float",
    "flophouse",
    "florence",
    "florentina",
    "flores",
    "florian",
    "florida",
    "florida1",
    "florin",
    "flow",
    "flower",
    "flowerpot",
    "flowers",
    "floyd",
    "fluffy",
    "flute",
    "fly",
    "flyaway",
    "flyboy",
    "flyer",
    "flyers",
    "flying",
    "flyingfuck",
    "flyingleap",
    "fnet",
    "foghorn",
    "fon",
    "fong",
    "foo",
    "foobar",
    "foobaz",
    "fool",
    "foolproof",
    "foot",
    "footbal",
    "football",
    "for",
    "foram",
    "forbidden",
    "ford",
    "forearm",
    "foresight",
    "forest",
    "forkedtounge",
    "format",
    "forrest",
    "forsythe",
    "fortune",
    "forum",
    "forum1",
    "forum123",
    "forumforum",
    "forumpass",
    "forward",
    "foster",
    "foulplay",
    "found",
    "fountain",
    "four",
    "fourier",
    "fourwheel",
    "fouryears",
    "fox",
    "foxtrot",
    "foxylady",
    "foxythekid",
    "fozzie",
    "fr13nd",
    "fr33d0m",
    "framemaker",
    "fran",
    "france",
    "frances",
    "francesc",
    "francesco",
    "francine",
    "francis",
    "francisc",
    "franco",
    "franco123",
    "francois",
    "frank",
    "frank1",
    "frank123",
    "franka",
    "frankenfurter",
    "frankfrank",
    "frankie",
    "franklin",
    "franknfurter",
    "frankpass",
    "fraser",
    "frat",
    "freak1",
    "freakbrothers",
    "fred",
    "fred1",
    "fred123",
    "freddie",
    "freddy",
    "frederic",
    "frederik",
    "fredfred",
    "fredpass",
    "fredric",
    "fredrick",
    "free",
    "freebird",
    "freebsd",
    "freebsd1",
    "freebsd123",
    "freebsdfreebsd",
    "freebsdpass",
    "freedom",
    "freeman",
    "freeze",
    "freeze112",
    "frei",
    "french",
    "french1",
    "frenchfries",
    "freshbread",
    "freshmeat",
    "friday",
    "friedric",
    "friend",
    "friends",
    "frighten",
    "frisco",
    "fritz",
    "frodo",
    "frog",
    "frog1",
    "froggie",
    "froggies",
    "froggy",
    "frogs",
    "from",
    "!front1er",
    "front242",
    "frontier",
    "frontpage",
    "frontpage1",
    "frontpage123",
    "frontpagefrontpage",
    "frontpagepass",
    "froshmeat",
    "frosty",
    "ftp",
    "ftp123",
    "ftpsecure",
    "ftpuser",
    "ftpuser123",
    "ftpusr",
    "ftpusr123",
    "fubar",
    "fuck",
    "fuckaduck",
    "fucked",
    "fuckem",
    "fucker",
    "fuckface",
    "fucking",
    "fuckit",
    "fuckleg",
    "fuckme",
    "fuckoff",
    "fuck-off",
    "fucku",
    "fuckyou",
    "fuck-you",
    "fugazi",
    "full",
    "fulton",
    "fun",
    "fun1",
    "fun123",
    "function",
    "funfun",
    "fungible",
    "funguy",
    "funky",
    "funny",
    "funpass",
    "funtime",
    "furball",
    "fuser",
    "future",
    "fuzbat",
    "fuzz",
    "fuzzball",
    "fuzzbat",
    "fv11r01rc3@l",
    "g9l2d1fzpy",
    "gabby",
    "gabe",
    "gabriel",
    "gabriel123",
    "gabriell",
    "gabrielle",
    "gaby",
    "gad",
    "gadi",
    "gaelic",
    "gage",
    "gail",
    "gala",
    "galaga",
    "galaxian",
    "galaxy",
    "galen",
    "galileo",
    "gallagher",
    "gallery",
    "gallery1",
    "gallery123",
    "gallerygallery",
    "gallerypass",
    "gamal",
    "gambit",
    "gambler",
    "game",
    "games",
    "games123",
    "gamma",
    "gamma123",
    "gammaphi",
    "ganapath",
    "gandalf",
    "ganja",
    "gaoyuan",
    "garcia",
    "garden",
    "gardner",
    "gareth",
    "garey",
    "garfield",
    "garfunkel",
    "gargoyle",
    "garlic",
    "garnet",
    "garp",
    "garr",
    "garret",
    "garrett",
    "garrry",
    "garry",
    "garth",
    "gary",
    "gary1",
    "gary123",
    "garygary",
    "garypass",
    "gash",
    "gasman",
    "gast",
    "gast1",
    "gast123",
    "gaston",
    "gateway",
    "gateway2",
    "gator",
    "gator1",
    "gatt",
    "gauss",
    "gautam",
    "gave",
    "gaven",
    "gavriel",
    "gay",
    "gayke",
    "gaynor",
    "gedanken",
    "geena",
    "geffrey",
    "gemini",
    "gene",
    "general",
    "general1",
    "general123",
    "generalgeneral",
    "generalmanager",
    "generalpass",
    "genesis",
    "genius",
    "genoveva",
    "geo",
    "geof",
    "geoff",
    "geoffrey",
    "geography",
    "georg",
    "george",
    "george1",
    "george123",
    "george899",
    "georgegeorge",
    "georgepass",
    "georgia",
    "georgina",
    "gerald",
    "geraldine",
    "gerard",
    "gerardo",
    "gerd",
    "gergory",
    "german",
    "germany",
    "germany1",
    "geronimo",
    "gerrard",
    "gerry",
    "gerry1",
    "gerry123",
    "gerrygerry",
    "gerrypass",
    "gert",
    "gertrude",
    "get",
    "getfucked",
    "get fucked",
    "getlaid",
    "get laid",
    "getlost",
    "get lost",
    "getlost!",
    "getlucky",
    "getout",
    "getstuffed",
    "get stuffed",
    "ggeorge",
    "ggg",
    "gggg",
    "ggggg",
    "gggggg",
    "ggggggg",
    "gggggggg",
    "ghandi",
    "gholamal",
    "ghost",
    "gia",
    "giancarl",
    "giants",
    "gib",
    "gibbons",
    "gibson",
    "giffy",
    "gigi",
    "gil",
    "gilbert",
    "gilgamesh",
    "gilles",
    "gillian",
    "gilman",
    "gina",
    "ginger",
    "gingers",
    "ginnie",
    "gino",
    "giovanne",
    "giovanni",
    "giridhar",
    "girl",
    "girls",
    "giselle",
    "giuseppe",
    "give",
    "gizmo",
    "glacier",
    "gladys",
    "glen",
    "glenda",
    "gleneagles",
    "glenn",
    "glider1",
    "global",
    "gloria",
    "gloria1",
    "gloria123",
    "gloriagloria",
    "gloriapass",
    "gmoney",
    "gnats",
    "gnats123",
    "gnu",
    "gnuemacs",
    "gnus",
    "go",
    "goahead",
    "goalie",
    "goat",
    "goaway",
    "go away",
    "go away!",
    "goaway!",
    "goblin",
    "goblue",
    "gocougs",
    "god",
    "goddard",
    "godflesh",
    "godfrey",
    "godiva",
    "godzilla",
    "goes",
    "goethe",
    "goethe6750",
    "gofish",
    "goforit",
    "gofuckyourself",
    "go fuck yourself",
    "gohome",
    "going",
    "gojumpinalake",
    "go jump in a lake",
    "gold",
    "gold123",
    "golden",
    "goldfinger",
    "goldfish",
    "goldie",
    "golf",
    "golfer",
    "golfing",
    "gollum",
    "gone",
    "gonorrhea",
    "gonzales",
    "gonzalez",
    "gonzo",
    "goober",
    "good",
    "goodafternoon",
    "goodevening",
    "goodfight",
    "goodgrief",
    "goodjob",
    "goodluck",
    "good-luck",
    "goodmorning",
    "goodtimes",
    "goodwife",
    "goofus",
    "goofy",
    "google",
    "google.com",
    "goonight",
    "goose",
    "gopalon",
    "gopher",
    "gopher123",
    "gopinath",
    "gordan",
    "gordon",
    "gorgeous",
    "gorges",
    "gorog",
    "gosling",
    "goson",
    "gostraight",
    "got",
    "goto",
    "gotohell",
    "go to hell",
    "goto hell",
    "gouge",
    "gould",
    "gov",
    "goverment",
    "gowest",
    "gr3atwa1l",
    "grace",
    "gracie",
    "graeme",
    "graham",
    "grahm",
    "grail",
    "gramps",
    "grandma",
    "grant",
    "graphic",
    "graphics",
    "grateful",
    "gratefuldead",
    "gravis",
    "gray",
    "gray123",
    "graymail",
    "greasyspoon",
    "great",
    "greatwall",
    "greed",
    "green",
    "green123",
    "greenday",
    "greenline",
    "greeting",
    "greg",
    "greg1",
    "greg123",
    "gregg",
    "greggreg",
    "gregory",
    "gregpass",
    "gremlin",
    "gremlins",
    "grep",
    "greta",
    "gretal",
    "gretchen",
    "grete",
    "gretel",
    "gretta",
    "gretzky",
    "grey",
    "grey123",
    "griffey",
    "griffin",
    "gripe",
    "grissom",
    "grizzly",
    "groovy",
    "group",
    "grover",
    "grow",
    "grumpy",
    "gryphon",
    "gsite",
    "gt05",
    "gucci",
    "guenter",
    "guess",
    "guessit",
    "guest",
    "guest1",
    "guest123",
    "guest1234",
    "guest123456",
    "guestaccount",
    "guestguest",
    "guestpass",
    "guide",
    "guido",
    "guillerm",
    "guinevre",
    "guinness",
    "guitar",
    "guitar1",
    "gulukota",
    "gumby",
    "gumption",
    "gunner",
    "guns",
    "guntis",
    "guozhong",
    "gupi",
    "gurjot",
    "guru",
    "gus",
    "gustavo",
    "guy",
    "gwen",
    "gwenyth",
    "gymnast",
    "gypsy",
    "h0st",
    "h0st1ng",
    "h0st3r",
    "h0tr0d",
    "h2opolo",
    "h4cks4f3",
    "ha",
    "hack",
    "hacked",
    "hacker",
    "hackproof",
    "hacksafe",
    "had",
    "hadoop",
    "hafidh",
    "haftan",
    "haggis",
    "haha",
    "hai",
    "haibo",
    "hailey",
    "hairbag",
    "hairball",
    "hairil",
    "hakan",
    "hal",
    "hal9000",
    "hall",
    "hallelujah",
    "hallo",
    "halloween",
    "hallowell",
    "halt",
    "hamid",
    "hamilton",
    "hamlet",
    "hamlin",
    "hammer",
    "hammered",
    "hammond",
    "hampton",
    "hamster",
    "handily",
    "handwave",
    "handwaving",
    "han-gyoo",
    "hank",
    "hanna",
    "hannah",
    "hans",
    "hansel",
    "hansolo",
    "hanson",
    "hanspete",
    "hao",
    "happening",
    "happy",
    "happy1",
    "happy123",
    "happyday",
    "happyending",
    "hard",
    "hard2see",
    "hardcore",
    "harddisk",
    "hardi",
    "hardison",
    "hardware",
    "harkara",
    "harkonnen",
    "harlan",
    "harley",
    "harley1",
    "harlots",
    "harmonie",
    "harmony",
    "haro",
    "harold",
    "harriet",
    "harriett",
    "harris",
    "harrison",
    "harrold",
    "harry",
    "harry1",
    "harry123",
    "harryharry",
    "harrypass",
    "harue",
    "haruo",
    "harvard",
    "harvey",
    "has",
    "hasok",
    "hassan",
    "hate",
    "hatton",
    "hauhua",
    "have",
    "havivah",
    "hawaii",
    "hawk",
    "hawkeye",
    "hawkeye1",
    "hayes",
    "hayley",
    "hazel",
    "he",
    "headers",
    "headers1",
    "headers123",
    "headersheaders",
    "headerspass",
    "health",
    "health1",
    "healthy",
    "healthy1",
    "healthy123",
    "healthyhealthy",
    "healthypass",
    "hean",
    "heart",
    "heartbreak",
    "hearts",
    "heat",
    "heather",
    "heather1",
    "heather123",
    "heather2",
    "heatherheather",
    "heatherpass",
    "heaven",
    "hebrides",
    "hector",
    "hedgehog",
    "hee",
    "heeralal",
    "heesung",
    "heidi",
    "heike",
    "heikki",
    "heinlein",
    "heinrich",
    "heinz",
    "helen",
    "helena",
    "helene",
    "helge",
    "hell",
    "hellen",
    "hellena",
    "hello",
    "hello1",
    "hello123",
    "hello8",
    "hellohello",
    "hellopass",
    "helloworld",
    "help",
    "help1",
    "help123",
    "helpdesk",
    "helpdesk1",
    "helpdesk123",
    "helpdeskhelpdesk",
    "helpdeskpass",
    "helper",
    "helphelp",
    "helpme",
    "helppass",
    "hemant",
    "henderson",
    "hendrix",
    "henning",
    "henry",
    "henry1",
    "henry123",
    "henryhenry",
    "henrypass",
    "her",
    "herb",
    "herbert",
    "here",
    "herman",
    "hermes",
    "hernandez",
    "herpes",
    "hershey",
    "herve",
    "herzog",
    "hesdead",
    "he'sdead",
    "hesdeadjim",
    "he'sdeadjim",
    "heung",
    "hewlett",
    "heydude",
    "heythere",
    "hglg;hgp.dk",
    "hhh",
    "hhhh",
    "hhhhh",
    "hhhhhh",
    "hhhhhhh",
    "hhhhhhhh",
    "hiawatha",
    "hibernia",
    "hidden",
    "highland",
    "highlife",
    "hilarie",
    "hilary",
    "hilbert",
    "hilda",
    "hill",
    "hillary",
    "hillel",
    "him",
    "hiroguch",
    "hiroki",
    "hiroo",
    "hiroshi",
    "hiroyuki",
    "his",
    "histoire",
    "history",
    "hitachi",
    "hitchcock",
    "hithere",
    "hitler",
    "hkh,dh;",
    "hoa",
    "hoang",
    "hobbes",
    "hobbit",
    "hockey",
    "hockey1",
    "hocus",
    "hocuspocus",
    "hocus pocus",
    "hocus-pocus",
    "hok",
    "hola",
    "hold",
    "hole",
    "holiday",
    "holly",
    "holy",
    "holygrail",
    "holy grail",
    "holyshit",
    "homayoum",
    "home",
    "homeboxoffice",
    "homebrew",
    "homer",
    "homerj",
    "homework",
    "hon",
    "honda",
    "honda1",
    "honey",
    "hong",
    "hongkong",
    "hongphuc",
    "hongtao",
    "honkey",
    "hoodlum",
    "hooker",
    "hookers",
    "hoops",
    "hoosier",
    "hooters",
    "hooters2011",
    "hootie",
    "hope",
    "hopscotch",
    "horace",
    "horde",
    "horde123",
    "horizon",
    "hornet",
    "hornets",
    "horny",
    "horror",
    "horse",
    "horses",
    "horus",
    "hosanna",
    "hosannah",
    "hosehead",
    "host",
    "hosting",
    "hosting1",
    "hosting123",
    "hostinghosting",
    "hostingpass",
    "hostmaster",
    "hostmaster1",
    "hostmaster123",
    "hostmasterhostmaster",
    "hostmasterpass",
    "hot",
    "hotdog",
    "hotel",
    "hotels",
    "hotlips",
    "hotrod",
    "hottip",
    "houcine",
    "house",
    "housewife",
    "houston",
    "how",
    "howard",
    "howard93",
    "howell",
    "howie",
    "hplab",
    "hr",
    "hr1",
    "hr123",
    "hrhr",
    "hrpass",
    "hsin",
    "hsiuwen",
    "hspice",
    "html",
    "html1",
    "html123",
    "htmlhtml",
    "htmlpass",
    "http",
    "httpd",
    "httpd123",
    "httpdserver",
    "httpserver",
    "huang",
    "huasheng",
    "huawei",
    "huawei123",
    "huawei@123",
    "hubba",
    "hubbahubba",
    "hubert",
    "hudson",
    "huercal",
    "huey",
    "hugh",
    "hughes",
    "hugo",
    "hugues",
    "huiying",
    "humanresources",
    "humanresources1",
    "humanresources123",
    "humanresourcespass",
    "hummer",
    "humphrey",
    "hundt",
    "hung",
    "hungmok",
    "hunter",
    "hunting",
    "huong",
    "hurt",
    "husband",
    "huskers",
    "huskies",
    "hustler",
    "hutchins",
    "huu",
    "huyen",
    "huzur",
    "hwang",
    "hwansoo",
    "hydrogen",
    "hydroxyl",
    "hye",
    "hyman",
    "hyo",
    "hyon",
    "hyoung",
    "hyuk",
    "i",
    "iabg",
    "ian",
    "ian1",
    "ian123",
    "ianian",
    "ianpass",
    "ib6ub9",
    "ibanez",
    "ibeleive",
    "ibelieve",
    "ibm",
    "ibmpc",
    "ibmpcat",
    "ibmpcxt",
    "ibmsux",
    "ibrahim",
    "icap",
    "icecream",
    "iceman",
    "icon",
    "id",
    "idc!@",
    "idc@123",
    "identd",
    "identd123",
    "identical",
    "idiot",
    "idontknow",
    "if",
    "if6was9",
    "ifconfig",
    "iforget",
    "iforgot",
    "ignacio",
    "ignatius",
    "iguana",
    "ihacked",
    "ihao",
    "ihateyou",
    "ihtfp",
    "iii",
    "iiii",
    "iiiii",
    "iiiiii",
    "iiiiiii",
    "iiiiiiii",
    "ikolp",
    "ikonas",
    "ikuo",
    "ilan",
    "ileana",
    "ileen",
    "ilene",
    "ilmari",
    "iloveu",
    "iloveyou",
    "iloveyoubaby",
    "ilya",
    "im",
    "image",
    "imagine",
    "imap",
    "imap1",
    "imap123",
    "imapimap",
    "imappass",
    "imbroglio",
    "imin",
    "imok",
    "i'mok",
    "imokay",
    "i'mokay",
    "impact",
    "impala",
    "imperial",
    "imsl",
    "in",
    "ina",
    "include",
    "inderpal",
    "index",
    "india",
    "india123",
    "indian",
    "indiana",
    "indigo",
    "indigo123",
    "indira",
    "indonesia",
    "indra",
    "indya123",
    "info",
    "info1",
    "info123",
    "infoinfo",
    "infopass",
    "information",
    "information1",
    "information123",
    "informationpass",
    "informix",
    "ingemar",
    "ingmar",
    "ingo",
    "ingres",
    "ingress",
    "ingrid",
    "ingvar",
    "inheritthewind",
    "inigo",
    "inl0v3",
    "inna",
    "innocent",
    "innocuous",
    "inquiries",
    "inquiries1",
    "inquiries123",
    "inquiriesinquiries",
    "inquiriespass",
    "inquiry",
    "inquiry1",
    "inquiry123",
    "inquiryinquiry",
    "inquirypass",
    "insane",
    "insecure",
    "insertion",
    "inside",
    "insight",
    "inst",
    "install",
    "install123",
    "instruct",
    "intall",
    "integra",
    "integral",
    "intel",
    "inter",
    "intercourse",
    "intergame",
    "intergamee",
    "interleaf",
    "intern",
    "international",
    "international1",
    "international123",
    "internationalpass",
    "internet",
    "interracial",
    "into",
    "intrepid",
    "investor",
    "investor1",
    "investor123",
    "investorinvestor",
    "investorpass",
    "invinoveritas",
    "invisible",
    "invite",
    "inxs",
    "ioana",
    "iojsjd9887",
    "iomega",
    "iong",
    "ipinfo",
    "ipinfo1",
    "ipinfo123",
    "ipinfoipinfo",
    "ipinfopass",
    "iq",
    "ira",
    "iraf",
    "irc",
    "irc123",
    "ircd",
    "ircd123",
    "ircop",
    "ircserver",
    "ireland",
    "irene",
    "irenee",
    "iresha",
    "irfan",
    "irina",
    "irine",
    "iris",
    "iris10ho",
    "irish",
    "irishman",
    "irlande",
    "irma",
    "irmeli",
    "ironman",
    "irulian",
    "irvin",
    "irving",
    "is",
    "isa",
    "isaac",
    "isabel",
    "isabell",
    "isabella",
    "isabelle",
    "isaiah",
    "isajoke",
    "isel",
    "ishmael",
    "isi",
    "isidore",
    "isil",
    "isis",
    "island",
    "ismail",
    "israel",
    "isreal",
    "issam",
    "isto",
    "it",
    "italia",
    "italy",
    "its",
    "itsajoke",
    "it'sajoke",
    "itsok",
    "it'sok",
    "itsokay",
    "it'sokay",
    "itsybitsy",
    "itsy-bitsy",
    "ittybitty",
    "itty-bitty",
    "iuytrewq",
    "ivan",
    "ivory",
    "ivory123",
    "ivy",
    "iw14fi9j",
    "izzy",
    "j0ker",
    "j1l2t3",
    "jabber",
    "jack",
    "jack1",
    "jack123",
    "jacki",
    "jackie",
    "jackie1",
    "jackjack",
    "jackolantern",
    "jackpass",
    "jackson",
    "jacob",
    "jacqueline",
    "jacques",
    "jade",
    "jae",
    "jaeger",
    "jaejin",
    "jagger",
    "jaguar",
    "jahanshi",
    "jai",
    "jaik",
    "jaikne",
    "jaikumar",
    "jaime",
    "jaimie",
    "jain",
    "jainet68",
    "jakausjam4",
    "jake",
    "jakey",
    "jakov",
    "jamaica",
    "james",
    "james1",
    "james123",
    "jamesbond",
    "jamesjames",
    "jamespass",
    "jamey",
    "jamie",
    "jamilah",
    "jamison",
    "jamjam",
    "jan",
    "jana",
    "janaki",
    "jane",
    "jane1",
    "jane123",
    "janejane",
    "janek",
    "janel",
    "janepass",
    "janet",
    "janice",
    "janie",
    "jann",
    "janna",
    "jannine",
    "janny",
    "january",
    "janvier",
    "jany",
    "japan",
    "japanese",
    "japon",
    "jaqueline",
    "jared",
    "jarod",
    "jasho",
    "jashvant",
    "jasmin",
    "jasmine",
    "jason",
    "jason1",
    "jason123",
    "jasonjason",
    "jasonpass",
    "jaspal",
    "jasper",
    "jatema",
    "jatin",
    "javed",
    "javi",
    "javier",
    "jaws",
    "jay",
    "jay1",
    "jay123",
    "jayanta",
    "jayanth",
    "jayjay",
    "jayme",
    "jayne",
    "jaypass",
    "jayson",
    "jazmin",
    "jazmine",
    "jazz",
    "jboss",
    "je",
    "jean",
    "jean1",
    "jean123",
    "jeananda",
    "jean-baptiste",
    "jeanclaude",
    "jean-claude",
    "jeanette",
    "jeanfrancois",
    "jean-francois",
    "jeanine",
    "jeanjean",
    "jeanmichel",
    "jean-michel",
    "jeanna",
    "jeanne",
    "jeannie",
    "jeanpass",
    "jeanpierre",
    "jean-pierre",
    "jeanyves",
    "jean-yves",
    "jed",
    "jedi",
    "jeepcj",
    "jeepcj7",
    "jeepster",
    "jef",
    "jeff",
    "jeff1",
    "jeff123",
    "jeffery",
    "jeffjeff",
    "jeffpass",
    "jeffrey",
    "jeffrey1",
    "jehan",
    "jello",
    "jellystone",
    "jen",
    "jena",
    "jenifer",
    "jenkins",
    "jenn",
    "jennan",
    "jenni",
    "jennie",
    "jennifer",
    "jennifer1",
    "jennifer123",
    "jenniferjennifer",
    "jenniferpass",
    "jenny",
    "jenny1",
    "jenny123",
    "jennyjenny",
    "jennypass",
    "jens",
    "jensen",
    "jer",
    "jerald",
    "jeremiah",
    "jeremy",
    "jeremy1",
    "jeremy123",
    "jeremyjeremy",
    "jeremypass",
    "jericho",
    "jerome",
    "jerrard",
    "jerric",
    "jerrimy",
    "jerry",
    "jerry1",
    "jerry123",
    "jerryjerry",
    "jerrypass",
    "jersey",
    "jesse",
    "jesse1",
    "jessica",
    "jessica1",
    "jessica123",
    "jessicajessica",
    "jessicapass",
    "jessie",
    "jester",
    "jesus",
    "jesus1",
    "jesuschrist",
    "jethro",
    "jethroh",
    "jethrotull",
    "jetta1",
    "jeudi",
    "jewels",
    "jhonathan",
    "jhonny",
    "ji",
    "jiachen",
    "jiamima",
    "jian",
    "jianli",
    "jiann",
    "jianping",
    "jianwen",
    "jie",
    "jihong",
    "jikun",
    "jill",
    "jill1",
    "jill123",
    "jilljill",
    "jillpass",
    "jim",
    "jim1",
    "jim123",
    "jimbo",
    "jimbob",
    "jimi",
    "jimjim",
    "jimmin",
    "jimmy",
    "jimmy1",
    "jimmy123",
    "jimmyjimmy",
    "jimmypass",
    "jimpass",
    "jin",
    "jing",
    "jinsheng",
    "jiong",
    "jiseong",
    "jitendra",
    "jixian",
    "jjj",
    "jjjj",
    "jjjjj",
    "jjjjjj",
    "jjjjjjj",
    "jjjjjjjj",
    "jkl;",
    "jkl123",
    "jkm",
    "jnanchito",
    "jnye",
    "joan",
    "joanie",
    "joann",
    "joanna",
    "joanne",
    "joaquim",
    "jobs",
    "jobs1",
    "jobs123",
    "jobsjobs",
    "jobspass",
    "joby",
    "jocelyn",
    "jodi",
    "jodie",
    "jody",
    "joe",
    "joe1",
    "joe123",
    "joejoe",
    "joel",
    "joelle",
    "joena",
    "joepass",
    "joerg",
    "joey",
    "johan",
    "johann",
    "johanna",
    "johanna1",
    "john",
    "john1",
    "john123",
    "john316",
    "johnathan",
    "johnjohn",
    "johnlennon",
    "johnny",
    "johnny1",
    "johnny123",
    "johnnyjohnny",
    "johnnypass",
    "johnpass",
    "johnson",
    "join",
    "joinforfree",
    "join for free",
    "joji",
    "jojo",
    "joker",
    "joker1",
    "jole",
    "jon",
    "jonathan",
    "jonell",
    "jones",
    "jong",
    "jonggu",
    "jong-i",
    "joni",
    "jonny",
    "jordan",
    "jordan1",
    "jordan23",
    "jordie",
    "jorean",
    "jorge",
    "jose",
    "josee",
    "joseph",
    "josh",
    "joshua",
    "josiah",
    "josie",
    "jour",
    "journey",
    "joy",
    "joyce",
    "jr",
    "jrimla5225",
    "jsbach",
    "juan",
    "jubilee",
    "judas",
    "jude",
    "judi",
    "judianto",
    "judicael",
    "judith",
    "judy",
    "juggle",
    "juhani",
    "jui",
    "juicy",
    "jui-fen",
    "juillet",
    "juin",
    "julayne",
    "jule",
    "jules",
    "juli",
    "julia",
    "julia2",
    "julian",
    "juliana",
    "juliann",
    "julie",
    "julie1",
    "julie123",
    "juliejulie",
    "julien",
    "julienne",
    "juliepass",
    "juliet",
    "juliette",
    "julius",
    "july",
    "jumanji",
    "jumbo",
    "jumeaux",
    "jump",
    "jumpinalake",
    "jump in a lake",
    "jun",
    "june",
    "junebug",
    "jungle",
    "juni",
    "junior",
    "junior1",
    "juniper",
    "juping",
    "jupiter",
    "jussi",
    "just",
    "justdoit",
    "juste",
    "justforthe",
    "justice",
    "justice4",
    "justin",
    "justin1",
    "justin123",
    "justine",
    "justinjustin",
    "justinpass",
    "justu",
    "justyou",
    "jutta",
    "jvnc",
    "jyh",
    "kacey",
    "kacy",
    "kadosh",
    "kai",
    "kailey",
    "kaitlin",
    "kaitlyn",
    "kaka",
    "kakogawa",
    "kal007",
    "kalamazo",
    "kalappa",
    "kaleb",
    "kali",
    "kalyan",
    "kalyn",
    "kam",
    "kan",
    "kang",
    "kangaroo",
    "kaos",
    "kaptain",
    "kara",
    "karalee",
    "karen",
    "karen1",
    "karie",
    "karin",
    "karina",
    "karine",
    "karl",
    "karma",
    "kary",
    "karyn",
    "kasey",
    "kashtan",
    "kat",
    "kate",
    "katerina",
    "katherin",
    "katherine",
    "kathi",
    "kathleen",
    "kathreen",
    "kathrina",
    "kathrine",
    "kathryn",
    "kathy",
    "kati",
    "katie",
    "katie1",
    "katina",
    "katrina",
    "katsufum",
    "katydid",
    "kaveh",
    "kay",
    "kayla",
    "kaylen",
    "kaylie",
    "kb",
    "kcin",
    "keaton",
    "kecia",
    "kee",
    "keegan",
    "keep",
    "keeper",
    "keepout",
    "kees",
    "keh",
    "keisha",
    "keith",
    "keith1",
    "keith123",
    "keithkeith",
    "keithpass",
    "keller",
    "kelley",
    "kelly",
    "kelly1",
    "kelly123",
    "kellykelly",
    "kellypass",
    "kelsey",
    "kelvin",
    "ken",
    "ken1",
    "ken123",
    "kendall",
    "kenji",
    "kenken",
    "kennedy",
    "kenneth",
    "kenny",
    "kenobi",
    "kenpass",
    "kent",
    "kenton",
    "kenzo",
    "kerala",
    "kerberos",
    "keri",
    "kermit",
    "kernel",
    "kerri",
    "kerrie",
    "kerry",
    "kerrya",
    "keshav",
    "kester",
    "ketan",
    "ketchup",
    "kevin",
    "kevin1",
    "kevin123",
    "kevinkevin",
    "kevinpass",
    "kewl",
    "key",
    "keyboard",
    "keypad",
    "khan",
    "khanh",
    "khayroll",
    "khoanh",
    "khoi",
    "khong",
    "khosrow",
    "khueh",
    "khueh-ho",
    "khurshee",
    "kian",
    "kiang",
    "kianusch",
    "kiat",
    "kidder",
    "kids",
    "kieu",
    "kiki",
    "killer",
    "killme",
    "kilroy",
    "kim",
    "kimberly",
    "kimmo",
    "kimon",
    "kind",
    "kinder",
    "king",
    "kingandi",
    "kingdom",
    "kingfish",
    "kinglear",
    "kings",
    "kingsoft",
    "kinson",
    "kip",
    "kiran",
    "kirk",
    "kirkland",
    "kirsten",
    "kiscica123",
    "kiss",
    "kissa2",
    "kissme",
    "kit",
    "kitkat",
    "kitten",
    "kitten12",
    "kittens",
    "kitty",
    "kittycat",
    "kiwi",
    "kjhgfdsa",
    "kkk",
    "kkkk",
    "kkkkk",
    "kkkkkk",
    "kkkkkkk",
    "kkkkkkkk",
    "klaus",
    "kleenex",
    "klingon",
    "klingons",
    "klog",
    "kmem",
    "kmem123",
    "knickers",
    "knicks",
    "knight",
    "knights",
    "know",
    "knute",
    "koala",
    "koichi",
    "koji",
    "kokakola",
    "koko",
    "kombat",
    "kongjoo",
    "konrad",
    "kook",
    "kor",
    "korda",
    "kraig",
    "kramer",
    "kris",
    "krishna",
    "krishnam",
    "krista",
    "kristal",
    "kristen",
    "kristi",
    "kristie",
    "kristin",
    "kristina",
    "kristine",
    "kristy",
    "krystal",
    "krystyna",
    "krzysiek",
    "kufew3",
    "kun",
    "kundenserver",
    "kuo",
    "kurt",
    "kurtis",
    "kwan",
    "kwang",
    "kwok",
    "kwong",
    "kx028897chebeuname+a",
    "kyahn",
    "kyeongso",
    "kyle",
    "kym",
    "kyra",
    "l1nux",
    "l1nuxb0x",
    "l3tm31ns1de",
    "l7q1smpp",
    "lab",
    "lab1",
    "laboratory",
    "labtec",
    "lacey",
    "lacrosse",
    "laddie",
    "ladies",
    "ladle",
    "lady",
    "ladybug",
    "lager",
    "lahiru",
    "laid",
    "lake",
    "lakers",
    "lakota",
    "lakshman",
    "laktrebor010699",
    "lalit",
    "lalith",
    "lalitha",
    "lam",
    "lambda",
    "lambert",
    "lamer",
    "lamination",
    "lan",
    "lana",
    "lance",
    "lancer",
    "landry",
    "lapin",
    "lara",
    "larissa",
    "larkin",
    "larry",
    "larry1",
    "larry123",
    "larrylarry",
    "larrypass",
    "larson",
    "laser",
    "laserjet",
    "lassie1",
    "last",
    "lastango",
    "lasttango",
    "latenight",
    "laugh",
    "laura",
    "laura1",
    "laura123",
    "laura1981",
    "laurae",
    "lauralaura",
    "lauramae",
    "laurapass",
    "laurel",
    "lauren",
    "laurence",
    "laurent",
    "laurenz",
    "laurie",
    "laurinda",
    "laury",
    "lavinia",
    "law",
    "lawrence",
    "lawson",
    "lawyer",
    "lazare",
    "lazarus",
    "ldap",
    "lea",
    "leader",
    "leaf",
    "leah",
    "leann",
    "leanne",
    "lebedev",
    "lebesgue",
    "leblanc",
    "leddzeppelin",
    "ledzep",
    "ledzepp",
    "ledzeppelin",
    "led-zeppelin",
    "lee",
    "lee1",
    "lee123",
    "leelee",
    "leepass",
    "legal",
    "legend",
    "leger",
    "lehi3b15",
    "leison",
    "leisure",
    "leland",
    "lemon",
    "len",
    "lena",
    "lennon",
    "lenny",
    "lenore",
    "lenovo",
    "lenox",
    "leo",
    "leon",
    "leona",
    "leonard",
    "leonce",
    "leonid",
    "leopold",
    "leroi",
    "leroy",
    "les",
    "lesbian",
    "lesley",
    "leslie",
    "lespaul",
    "less",
    "lestat",
    "lester",
    "let",
    "leticia",
    "letlive",
    "letmein",
    "leto",
    "letsgo",
    "letter",
    "letters",
    "letters1",
    "letters123",
    "lettersletters",
    "letterspass",
    "lev",
    "lewis",
    "lexus1",
    "lez",
    "lg",
    "li",
    "lib",
    "liberty",
    "libra",
    "library",
    "licensing",
    "licensing1",
    "licensing123",
    "licensinglicensing",
    "licensingpass",
    "lick",
    "licker",
    "licorne",
    "lien",
    "liew",
    "life",
    "light",
    "lights",
    "like",
    "lillian",
    "lilly",
    "lily",
    "lima",
    "limited",
    "lin",
    "linc",
    "lincoln",
    "linda",
    "linda1",
    "linda123",
    "lindalinda",
    "lindapass",
    "lindsay",
    "lindsey",
    "lindy",
    "ling",
    "linh",
    "link",
    "link1",
    "link123",
    "linkexchange",
    "linkexchange1",
    "linkexchange123",
    "linkexchangepass",
    "linklink",
    "linkpass",
    "links",
    "links1",
    "links123",
    "linkslinks",
    "linkspass",
    "linrex413",
    "linux",
    "linuxbox",
    "linuxtest",
    "linuxtester",
    "linuxtester2",
    "lion",
    "lionel",
    "lionking",
    "lions",
    "lisa",
    "lisa1",
    "lisa123",
    "lisalisa",
    "lisapass",
    "lise",
    "lisp",
    "lissabon",
    "list",
    "list1",
    "list123",
    "listlist",
    "listpass",
    "listproc",
    "listproc1",
    "listproc123",
    "listproclistproc",
    "listprocpass",
    "lists",
    "lists123",
    "listserv",
    "listserv1",
    "listserv123",
    "listservlistserv",
    "listservpass",
    "litterbox",
    "little",
    "littlehouse",
    "littleshit",
    "littleshop",
    "littletoe",
    "live",
    "liveandletlive",
    "livenletlive",
    "liverpoo",
    "liverpool",
    "lives",
    "livia",
    "living",
    "liwana",
    "liz",
    "liz1",
    "liz123",
    "liza",
    "lizard",
    "lizzy",
    "ljf",
    "ljiljana",
    ";lk",
    ";lkasd",
    "lkj",
    "lkjasd",
    "lkjh",
    "lkjhg",
    "lkjhgf",
    "lkjhgfds",
    "lkjhgfdsa",
    "';lkjhgfdsa",
    "lkjlkj",
    ";lk;lk",
    "llewelly",
    "lll",
    "llll",
    "lllll",
    "llllll",
    "lllllll",
    "llllllll",
    "lloyd",
    "lmnop",
    "lnx",
    "local",
    "localhost",
    "loch",
    "lock",
    "lockout",
    "log",
    "logan",
    "logger",
    "logical",
    "login",
    "logos",
    "logout",
    "logrotate",
    "logrotate1",
    "logrotate123",
    "logrotatelogrotate",
    "logrotatepass",
    "logs",
    "logs123",
    "lois",
    "loislane",
    "loke",
    "loki",
    "lol",
    "lola",
    "lolita",
    "lolopc",
    "london",
    "lonely",
    "lonestar",
    "long",
    "longcock",
    "longer",
    "longhair",
    "longhorn",
    "longrest",
    "longtounge",
    "look",
    "lookatme123",
    "looney",
    "loose",
    "loosing",
    "lopez",
    "loren",
    "lorenzo",
    "loretta",
    "lori",
    "lorie",
    "lorin",
    "lorna",
    "lorraine",
    "lorrie",
    "lory",
    "losangeles",
    "loser",
    "lost",
    "lotfi",
    "lotus",
    "lotus123",
    "lou",
    "louie",
    "louis",
    "louisa",
    "louise",
    "louise1",
    "lounette",
    "lourdes",
    "love",
    "lovely",
    "loveme",
    "lover",
    "loverboy",
    "lovers",
    "loveyou",
    "lowgrade",
    "lowlife",
    "lp",
    "lp123",
    "lpadmin",
    "lpdaemon",
    "ls",
    "lsd",
    "ltte",
    "luana",
    "luc",
    "lucas",
    "lucia",
    "lucie",
    "lucien",
    "lucifer",
    "lucille",
    "lucky",
    "lucky1",
    "lucky14",
    "luckybreak",
    "luckylady",
    "lucy",
    "ludovic",
    "luigi",
    "luis",
    "luiz",
    "luke",
    "lulu",
    "lumiere",
    "lunarlander",
    "lundi",
    "lune",
    "lung",
    "luong",
    "luther",
    "lydia",
    "lydie",
    "lyle",
    "lyn",
    "lyndon",
    "lynette",
    "lynn",
    "lynne",
    "lynx",
    "m",
    "/.,m",
    ".,m",
    "m00nl1ght",
    "m1911a1",
    "m1tn1ck",
    "m3ss3ng3r",
    "m4gn3t",
    "m4gnet",
    "m4r1b0r0",
    "m4rlb0r0",
    "m4rlboro",
    "ma1ls3rv3r",
    "maarten",
    "mac",
    "macha",
    "machine",
    "macintos",
    "macintosh",
    "mack",
    "macromedia",
    "macross",
    "macse30",
    "macsyma",
    "mad",
    "madboy",
    "maddie",
    "maddock",
    "maddog",
    "made",
    "madeleine",
    "madelene",
    "madeline",
    "madhu",
    "madhuri",
    "madhusud",
    "madison",
    "madman",
    "madmax",
    "madoka",
    "madonna",
    "mady",
    "magdalen",
    "magenta",
    "magenta123",
    "maggie",
    "maggot",
    "magic",
    "magic1",
    "magique",
    "magn1f1c",
    "magn3t",
    "magnet",
    "magnific",
    "magnum",
    "mahbuba",
    "mahesh",
    "mahlon",
    "mahmoud",
    "mai",
    "maia",
    "maiden",
    "mail",
    "mail1",
    "mail123",
    "mailbox",
    "mailbox1",
    "mailbox123",
    "mailboxmailbox",
    "mailboxpass",
    "mailer",
    "mailinglist",
    "mailmail",
    "mailman",
    "mailman123",
    "mailnull",
    "mailnull123",
    "mailpass",
    "mails3rv3r",
    "mailserver",
    "mailtest",
    "mailusers",
    "maine",
    "mainsail",
    "maint",
    "major",
    "majordom",
    "majordom123",
    "majordomo",
    "majordomo1",
    "majordomo123",
    "majordomomajordomo",
    "majordomopass",
    "mak3l0ve",
    "make",
    "makebread",
    "makedrugs",
    "makeit",
    "makeitso",
    "makelove",
    "makeme",
    "makemyday",
    "makepeace",
    "makewar",
    "makingit",
    "makinglove",
    "makoto",
    "malcolm",
    "malcom",
    "malibu",
    "malika",
    "mallard",
    "mama",
    "mambo",
    "man",
    "man123",
    "manageme",
    "manager",
    "manager1",
    "manager123",
    "managermanager",
    "managerpass",
    "manahil",
    "manbat",
    "manchester",
    "mandrake",
    "mandrake10",
    "mandrake80",
    "mandrake91",
    "mandy",
    "manfred",
    "mangesh",
    "mangue",
    "mani",
    "manish",
    "manohar",
    "manoj",
    "manon",
    "mansetmanis",
    "manson",
    "mantra",
    "manuel",
    "many",
    "maplesyrup",
    "mara",
    "marathon",
    "marc",
    "marc1",
    "marc123",
    "marcel",
    "marcella",
    "marcelle",
    "marcellin",
    "march",
    "marci",
    "marcia",
    "marcio",
    "marcmarc",
    "marco",
    "marcpass",
    "marcus",
    "marcy",
    "mardi",
    "marek",
    "margalit",
    "margaret",
    "margarid",
    "margarit",
    "margaux",
    "marge",
    "margeaux",
    "margie",
    "margo",
    "marguerite",
    "maria",
    "maria1",
    "maria123",
    "mariah",
    "mariah1",
    "mariamaria",
    "marian",
    "mariana",
    "mariana123",
    "marianne",
    "mariapass",
    "marie",
    "marielle",
    "marie-madeleine",
    "marietta",
    "mariette",
    "marilyn",
    "marina",
    "marine",
    "mariner",
    "marino",
    "mario",
    "marion",
    "mariposa",
    "maritial",
    "marius",
    "marjory",
    "mark",
    "mark1",
    "mark123",
    "market",
    "marketing",
    "marketing1",
    "marketing123",
    "marketingmarketing",
    "marketingpass",
    "markmark",
    "marko",
    "markpass",
    "markus",
    "marlb0r0",
    "marlboro",
    "marlena",
    "marlene",
    "marley",
    "marni",
    "maroon",
    "maroon123",
    "marriage",
    "marrucci",
    "mars",
    "marshal",
    "marshall",
    "mart",
    "martha",
    "martha123",
    "marthe",
    "marti",
    "martial",
    "martin",
    "martin1",
    "martin123",
    "martine",
    "martinez",
    "martinien",
    "martiniq",
    "martinmartin",
    "martinpass",
    "marty",
    "marty1",
    "marty123",
    "martymarty",
    "martypass",
    "marvin",
    "mary",
    "mary1",
    "mary123",
    "maryam",
    "maryann",
    "maryjane",
    "marymary",
    "marypass",
    "maryse",
    "maryse1",
    "marzec",
    "masahiro",
    "mase",
    "mash4077",
    "masoud",
    "mass",
    "masscomp",
    "master",
    "master1",
    "master123",
    "masters",
    "masuhiro",
    "math",
    "math-cs",
    "mathilde",
    "matilda",
    "matrix",
    "matt",
    "matt1",
    "matt123",
    "matt2006",
    "matt2007",
    "matther",
    "matthew",
    "matthew1",
    "matthew123",
    "matthewmatthew",
    "matthewpass",
    "matthias",
    "matthieu",
    "matti1",
    "mattingly",
    "mattmatt",
    "mattpass",
    "maude",
    "maui",
    "maureen",
    "maurice",
    "mauricio",
    "mauro",
    "maveric",
    "maverick",
    "max",
    "maxime",
    "maxine",
    "maxmax",
    "maxwell",
    "maxwellsmart",
    "may",
    "maya",
    "mayday",
    "mazda1",
    "mazin",
    "mb",
    "mdb",
    "mdom",
    "me",
    "me1",
    "me123",
    "meagan",
    "meat",
    "meatcleaver",
    "meatloaf",
    "meatwagon",
    "mech",
    "mechanic",
    "medard",
    "media",
    "media1",
    "media123",
    "mediamedia",
    "mediapass",
    "medical",
    "meekie",
    "meg",
    "meg1",
    "meg123",
    "mega",
    "megadeth",
    "megan",
    "megasecret",
    "meggie",
    "megmeg",
    "megpass",
    "meister",
    "mel",
    "melaine",
    "melanie",
    "melina",
    "melinda",
    "melisa",
    "melissa",
    "melissa1",
    "melissa123",
    "melissamelissa",
    "melissapass",
    "mella",
    "mellon",
    "melody",
    "meltin",
    "member",
    "membership",
    "membership1",
    "membership123",
    "membershipmembership",
    "membershippass",
    "meme",
    "memory",
    "memphis",
    "men",
    "mendel",
    "mensuck",
    "menu",
    "meow",
    "mepass",
    "mercedes",
    "mercer",
    "mercredi",
    "mercure",
    "mercury",
    "merde",
    "meres",
    "merlin",
    "merlot",
    "mermaid",
    "merrell",
    "merrill",
    "merrychristmas",
    "metal",
    "metallic",
    "metallica",
    "metro",
    "mets",
    "mexico",
    "mgomez",
    "mgonzalez",
    "mgr",
    "mh",
    "mh1",
    "mh123",
    "mh3i5lik3p4rty@v3r",
    "mhmh",
    "mhpass",
    "mia",
    "miami",
    "michael",
    "michael.",
    "michael1",
    "michael123",
    "michaelmichael",
    "michaelpass",
    "michaels",
    "michal",
    "michel",
    "michel1",
    "michele",
    "michell",
    "michelle",
    "michelle1",
    "michelle123",
    "michellemichelle",
    "michellepass",
    "michigan",
    "michou",
    "michy",
    "mickel",
    "mickey",
    "mickey1",
    "micky",
    "micro",
    "microsoft",
    "midnight",
    "midnightcommander",
    "midori",
    "midvale",
    "midway",
    "might",
    "miguel",
    "mihail",
    "mihran",
    "mikael",
    "mike",
    "mike1",
    "mike123",
    "mikemike",
    "mikepass",
    "mikey",
    "miki",
    "mikko",
    "milano",
    "mildred",
    "miles",
    "milind",
    "milk",
    "millard",
    "millenium",
    "miller",
    "millicen",
    "millie",
    "million",
    "milo",
    "milton",
    "mimi",
    "mindy",
    "mine",
    "mined",
    "minerva",
    "ming",
    "minghe",
    "minh",
    "minimum",
    "minnie",
    "minot",
    "minou",
    "minsky",
    "minye",
    "miracle",
    "mirage",
    "miranda",
    "mirelageorgeana",
    "miriam",
    "mirror",
    "misanthrope",
    "misha",
    "mishka",
    "misogynist",
    "mission",
    "missirli",
    "missy",
    "misty",
    "mit",
    "mitch",
    "mitchell",
    "mitnick",
    "mittens",
    "mivamerchant",
    "mivamerchant1",
    "mivamerchant123",
    "mivamerchantpass",
    "mkdir",
    "mmm",
    "mmmm",
    "mmmmm",
    "mmmmmm",
    "mmmmmmm",
    "mmmmmmmm",
    "mmouse",
    "/.,mn",
    ".,mn",
    "mnb",
    "/.,mnb",
    ".,mnb",
    "mnbv",
    "mnbvc",
    "mnbvcx",
    "mnbvcxz",
    "/.,mnbvcxz",
    "mobile",
    "mobydick",
    "models",
    "modem",
    "modeste",
    "mod_perl",
    "mod_perl1",
    "mod_perl123",
    "mod_perlmod_perl",
    "mod_perlpass",
    "modula",
    "mogens",
    "mogul",
    "moguls",
    "mohamed",
    "mohammad",
    "mohammed",
    "mohan",
    "moises",
    "moishe",
    "moja",
    "mojo",
    "molly",
    "molly1",
    "molly123",
    "molson",
    "molsongolden",
    "mom",
    "mom123",
    "mona",
    "monday",
    "monday44",
    "monet",
    "money",
    "money1",
    "mongd123",
    "moni",
    "monica",
    "monika",
    "monique",
    "monitor",
    "monkey",
    "monkey1",
    "monopoly",
    "monroe",
    "monster",
    "mont",
    "montana",
    "montana3",
    "month",
    "montreal",
    "montrose",
    "monty",
    "moocow",
    "mookie",
    "moomoo",
    "moon",
    "moonbeam",
    "moonglow",
    "moonpie",
    "moore",
    "moorhty",
    "moose",
    "moosehea",
    "moosehead",
    "mopar",
    "mora",
    "more",
    "morecats",
    "morgan",
    "morley",
    "moroni",
    "morpheus",
    "morris",
    "mort",
    "mortimer",
    "morts",
    "mose",
    "moshe",
    "mother",
    "motor",
    "motorola",
    "motown",
    "mou",
    "mountain",
    "mouse",
    "mouse1",
    "mousemat",
    "mousumi",
    "movies",
    "mowgli",
    "mozart",
    "mr.",
    "mrcharlie",
    "mrgoodbar",
    "mr.roger",
    "mrwonderful",
    "mssucks!",
    "mtichell",
    "mtxinu",
    "mt.xinu",
    "muaddib",
    "muad-dib",
    "muamadin",
    "much",
    "muffin",
    "muh",
    "muhammad",
    "mukesh",
    "mukund",
    "mulder",
    "mulder1",
    "munaish",
    "munchkin",
    "mundeep",
    "murphy",
    "murray",
    "muscle",
    "music",
    "music1",
    "music123",
    "musicbox",
    "musicmusic",
    "musicpass",
    "musim",
    "mustang",
    "mustang1",
    "mutant",
    "mv",
    "my",
    "mycroftxxx",
    "mycroftyyy",
    "mypasswd",
    "mypassword",
    "myra",
    "myron",
    "myrtle",
    "myself",
    "mysmut",
    "mysql",
    "mysql1",
    "mysql123",
    "mysqlmysql",
    "mysqlpass",
    "mysqlserver",
    "myung",
    "myung-yu",
    "n0chanc3",
    "n0h4ck",
    "n2h2",
    "nabil",
    "nadege",
    "nader",
    "nadia",
    "nadine",
    "naftaly",
    "nagel",
    "nagios",
    "nagios1",
    "nagiosuser",
    "naissance",
    "nakamichi",
    "nalini",
    "name",
    "name1",
    "name123",
    "named",
    "named123",
    "namename",
    "namepass",
    "nameserver",
    "nan",
    "nancy",
    "nancy1",
    "nancy123",
    "nancynancy",
    "nancypass",
    "nanette",
    "nano",
    "nanouser",
    "nanouser123",
    "naomi",
    "naoto",
    "napoleon",
    "narciso",
    "narcisse",
    "narendra",
    "nasa",
    "nasa123",
    "nasagov",
    "nascar",
    "nasty",
    "nat",
    "natacha",
    "natalia",
    "natalie",
    "nataraja",
    "natasha",
    "nathalie",
    "nathan",
    "nathanae",
    "nathanie",
    "nation",
    "national",
    "nationale",
    "nativite",
    "nautica",
    "naveen",
    "navette",
    "navy",
    "ncar",
    "ncc1701",
    "ncc1701d",
    "ncc1701e",
    "ncr",
    "ne1410s",
    "ne1469",
    "ne14a69",
    "neal",
    "nearmiss",
    "nebraska",
    "neckrub",
    "ned",
    "neenie",
    "neetha",
    "neil",
    "neko",
    "nellie",
    "nelson",
    "nemesis",
    "nena",
    "neo",
    "neon1661",
    "nepenthe",
    "nepenthes",
    "neptune",
    "nermal",
    "nesbit",
    "nesbitt",
    "ness",
    "nestle",
    "nestor",
    "net",
    "netdump",
    "netdump123",
    "netlinks",
    "netmgr",
    "netscape",
    "netstat",
    "netware",
    "network",
    "networks",
    "neutrino",
    "nevada",
    "never",
    "neville",
    "new",
    "newaccount",
    "newblood",
    "newcourt",
    "newkid",
    "newkids",
    "newlife",
    "newpass",
    "news",
    "news1",
    "news123",
    "newsletter",
    "newsletter1",
    "newsletter123",
    "newsletternewsletter",
    "newsletterpass",
    "newsnews",
    "newspass",
    "newton",
    "newuser",
    "newusers",
    "newworld",
    "newyork",
    "newyork1",
    "next",
    "nexus6",
    "nfsnobody",
    "nfsnobody123",
    "nghi",
    "ngoc",
    "nguyen",
    "nicarao",
    "nicholas",
    "nichole",
    "nick",
    "nick1",
    "nick123",
    "nickelan",
    "nicklaus",
    "nicknick",
    "nickpass",
    "nicolas",
    "nicole",
    "nicole1",
    "nicole123",
    "nicolenicole",
    "nicolepass",
    "niel",
    "nigel",
    "nigger",
    "nightmare",
    "nightshadow",
    "nightwal",
    "nightwind",
    "nihaoma",
    "nike",
    "nikhil",
    "niki",
    "nikita",
    "nikki",
    "nikolaos",
    "nilson",
    "nimda",
    "nimh",
    "nimrod",
    "nina",
    "nine",
    "niners",
    "nino",
    "ninon",
    "nintendo",
    "nirvana",
    "nirvana1",
    "nissan",
    "nisse",
    "nita",
    "nite",
    "nks230kjs82",
    "nnn",
    "nnnn",
    "nnnnn",
    "nnnnnn",
    "nnnnnnn",
    "nnnnnnnn",
    "no",
    "noam",
    "nobody",
    "nobody1",
    "nobody123",
    "nobody4",
    "nobodynobody",
    "nobodypass",
    "nobuhiko",
    "nobuko",
    "noc",
    "nochance",
    "noel",
    "nofun",
    "nohack",
    "nohackhere",
    "nokia",
    "nolan",
    "nologin",
    "nomore",
    "nondet",
    "none",
    "none1",
    "nopass",
    "nopassword",
    "nora",
    "norbert",
    "noreen",
    "norene",
    "noreply",
    "noreply1",
    "noreply123",
    "noreplynoreply",
    "noreplypass",
    "noriko",
    "norma",
    "normal",
    "norman",
    "north",
    "northwest",
    "norton",
    "nosecret",
    "noshir",
    "nospam",
    "nospam1",
    "nospam123",
    "nospamnospam",
    "nospampass",
    "not",
    "notebook",
    "notes",
    "notgay",
    "nothing",
    "notre",
    "notrespass",
    "notta1",
    "notused",
    "nouveau",
    "novacancy",
    "novell",
    "november",
    "novembre",
    "now",
    "noway",
    "noxious",
    "nroff",
    "ns",
    "n@s@",
    "nsadmin",
    "nss",
    "nsserver",
    "n@t412108",
    "nuclear",
    "nugget",
    "nuke",
    "nukem",
    "null",
    "number",
    "number1",
    "number9",
    "numberone",
    "numbers",
    "nurse",
    "nursie",
    "nut",
    "nutmeg",
    "nutrition",
    "nuucp",
    "nyquist",
    "o9q1w2e3i8u7",
    "oa",
    "oatmeal",
    "oaxaca",
    "obelix",
    "obelix123",
    "obi",
    "obi kenobi",
    "obiwan",
    "obi-wan",
    "obi wan kenobi",
    "object",
    "obsession",
    "ocean",
    "oceanography",
    "ocelot",
    "octavia",
    "october",
    "octobre",
    "odette",
    "odile",
    "odilon",
    "of",
    "off",
    "office",
    "office1",
    "office123",
    "officeoffice",
    "officepass",
    "offl1ne",
    "ohshit",
    "ohwell",
    "oicu812",
    "oil",
    "oivind",
    "ojrind",
    "ok",
    "okmnji",
    "old",
    "oldlady",
    "oldpussy",
    "olin",
    "olive",
    "oliver",
    "olivetti",
    "olivia",
    "olivier",
    "ollie",
    "olsen",
    "omead",
    "omega",
    "omega123",
    "on",
    "once",
    "one",
    "onionrings",
    "onl1ne",
    "online",
    "online1",
    "online123",
    "onlineonline",
    "onlinepass",
    "only",
    "only4me",
    "onlyme",
    "onlyu",
    "onstad",
    "ooo",
    "oooo",
    "ooooo",
    "oooooo",
    "ooooooo",
    "oooooooo",
    "oops",
    "open",
    "openbar",
    "opendesktop",
    "opendoor",
    "openelec",
    "opensaysme",
    "opensesame",
    "openssl",
    "openup",
    "oper",
    "opera",
    "operations",
    "operator",
    "operator123",
    "opus",
    "or",
    "oracle",
    "oracle1",
    "oracle123",
    "oracle123456",
    "oracle9i",
    "orange",
    "orange123",
    "orangeline",
    "oranges",
    "orca",
    "orchid",
    "order",
    "order1",
    "order123",
    "orderorder",
    "orderpass",
    "oregon",
    "oreo",
    "orgasm",
    "orion",
    "orlando",
    "orville",
    "orwell",
    "oscar",
    "osiris",
    "osulliva",
    "oswald",
    "othar",
    "other",
    "otter",
    "otto",
    "ou812",
    "our",
    "oussama",
    "out",
    "outlaw",
    "outtolunch",
    "over",
    "overkill",
    "overthrow",
    "overtime",
    "owen",
    "own",
    "owns",
    "oxford",
    "ozzie",
    "ozzy",
    "p",
    "@p0ll0",
    "p0o9i8u7y6t5r4e3w2q1",
    "p0stgr3s",
    "p1a2s3s4w5o6r7d8",
    "p$1c*k0n3h",
    "p4ssw0rd",
    "p@55w0rd",
    "pa55w0rd",
    "pa55word",
    "paagal",
    "pacers",
    "pacific",
    "pacifique",
    "packard",
    "packer",
    "packers",
    "packrat",
    "pad",
    "padaaa",
    "paddy",
    "padma",
    "padoue",
    "page",
    "paige",
    "painless",
    "paint",
    "paintball",
    "painter",
    "pakistan",
    "paladin",
    "pallab",
    "palmer",
    "paloma",
    "pam",
    "pamela",
    "pampers",
    "pancake",
    "panda",
    "pandora",
    "panel",
    "panic",
    "pantera",
    "panther",
    "panties",
    "papa",
    "paper",
    "papers",
    "papiers",
    "pappas",
    "paques",
    "paradigm",
    "paradise",
    "parallel",
    "paranoia",
    "paraskev",
    "parfait",
    "paris",
    "park",
    "parker",
    "parkins",
    "parola",
    "parrot",
    "part",
    "partner",
    "partners",
    "partners1",
    "partners123",
    "partnerspartners",
    "partnerspass",
    "parton",
    "parts",
    "parts1",
    "parts123",
    "partsparts",
    "partspass",
    "parviz",
    "pascal",
    "pass",
    "pass123",
    "pass1234",
    "pass1478",
    "passion",
    "passsave",
    "passw0rd",
    "passwd",
    "passwd123",
    "passwor",
    "password",
    "password01",
    "password1",
    "password123",
    "passwordlookhere",
    "passwordx",
    "pat",
    "pat1",
    "pat123",
    "patches",
    "patel",
    "paterne",
    "patpass",
    "patpat",
    "patrice",
    "patricia",
    "patrick",
    "patrick1",
    "patrick123",
    "patrickpass",
    "patrickpatrick",
    "patriots",
    "patsy",
    "patterson",
    "patti",
    "patton",
    "patty",
    "paul",
    "paul1",
    "paul123",
    "paula",
    "paule",
    "paulin",
    "pauline",
    "paulo",
    "paulo123",
    "paulpass",
    "paulpaul",
    "pavel",
    "pavila",
    "pavila123",
    "pa$$w0rd",
    "pawan",
    "pa$$word",
    "payman",
    "payment",
    "payment1",
    "payment123",
    "paymentpass",
    "paymentpayment",
    "payments",
    "payments1",
    "payments123",
    "paymentspass",
    "paymentspayments",
    "paypal",
    "paypal1",
    "paypal123",
    "paypalpass",
    "paypalpaypal",
    "payton",
    "pcap",
    "pcap123",
    "pcat",
    "pcxt",
    "peace",
    "peach",
    "peaches",
    "peanut",
    "peanutbutter",
    "peanuts",
    "pearl",
    "pearljam",
    "pebbles",
    "peche",
    "pecheur",
    "pecheurs",
    "pedro",
    "pedro1",
    "peebles",
    "peewee",
    "pegasus",
    "peggy",
    "peh",
    "pekka",
    "pelagie",
    "pencil",
    "penelope",
    "penguin",
    "penis",
    "penny",
    "pentagon",
    "pentecote",
    "pentium",
    "pentti",
    "people",
    "peoria",
    "pepper",
    "pepsi",
    "peraka",
    "percolate",
    "percy",
    "peres",
    "perez",
    "perfect",
    "performa",
    "perry",
    "persimmon",
    "person",
    "persona",
    "peru",
    "pervert",
    "pete",
    "peter",
    "peter1",
    "peter123",
    "peterk",
    "peterpan",
    "peterpass",
    "peterpeter",
    "peterson",
    "petey",
    "petunia",
    "peugeot",
    "peur",
    "pgonderin",
    "pgsql",
    "pgsql123",
    "pham",
    "phantom",
    "phialpha",
    "phil",
    "phil1",
    "phil123",
    "philip",
    "philippe",
    "philips",
    "phillip",
    "phillips",
    "philpass",
    "philphil",
    "phish",
    "phishy",
    "phoenix",
    "phoenix1",
    "phone",
    "photo",
    "photos",
    "photos1",
    "photos123",
    "photoshop",
    "photospass",
    "photosphotos",
    "php",
    "phpbb",
    "phrack",
    "phreak",
    "phrick",
    "phyllis",
    "physics",
    "pi",
    "piano",
    "piano1",
    "pianoman",
    "pianos",
    "picard",
    "picasso",
    "pick",
    "pickle",
    "pico",
    "picture",
    "pierce",
    "pierre",
    "pieter",
    "pigeon",
    "piglet",
    "pimp",
    "pin",
    "ping",
    "pink",
    "pink123",
    "pinkfloy",
    "pinkfloyd",
    "pioneer",
    "piotr",
    "pipeline",
    "pipeorgan",
    "piper1",
    "pirate",
    "pirie",
    "pisces",
    "pit",
    "pitboss",
    "pitboss1",
    "pitboss123",
    "pitbosspass",
    "pitbosspitboss",
    "pizza",
    "pl3xiglass",
    "plaintruth",
    "plane",
    "planet",
    "plato",
    "play",
    "playboy",
    "player",
    "players",
    "playground",
    "plcmspip",
    "please",
    "plex1glass",
    "plexiglass",
    "plier",
    "plover",
    "plugh",
    "plumbrandy",
    "plus",
    "pluto",
    "pluton",
    "plymouth",
    "pm",
    "pm7khapd",
    "pmc",
    "pmok",
    "pocus",
    "poczta",
    "poetic",
    "poetry",
    "poh",
    "poir",
    "poire",
    "poisson",
    "poissons",
    "poiu",
    "poiuy",
    "poiuyt",
    "poiuytre",
    "poiuytrewq",
    "][poiuytrewq",
    "polamea",
    "polar",
    "polarbear",
    "polaris",
    "pole",
    "police",
    "politics",
    "polly",
    "polo",
    "polynomial",
    "pomme",
    "pondering",
    "pontiac",
    "pooh",
    "poohbear",
    "pookey",
    "pookie",
    "pookie1",
    "pop",
    "pop123",
    "popa3d",
    "popa3d123",
    "popcorn",
    "pope",
    "popeye",
    "poppy",
    "porc",
    "pork",
    "porky",
    "porn",
    "pornbay",
    "pornman",
    "porno",
    "pornography",
    "porsche",
    "porsche9",
    "porsche911",
    "porsche914",
    "portal",
    "porter",
    "portland",
    "portnoy",
    "posfix",
    "post",
    "postel",
    "poster",
    "postfix",
    "postfix123",
    "postgre123",
    "postgres",
    "postgres123",
    "postgresql",
    "postgresql1",
    "postgresql123",
    "postgresqlpass",
    "postgresqlpostgresql",
    "postmaster",
    "postmaster1",
    "postmaster123",
    "postmasterpass",
    "postmasterpostmaster",
    "powell",
    "power",
    "powerpc",
    "powertool",
    "ppp",
    "ppp123",
    "pppp",
    "ppppp",
    "pppppp",
    "ppppppp",
    "pppppppp",
    "pr",
    "pr1",
    "pr123",
    "prabhaka",
    "prabhu",
    "prabir",
    "pradeep",
    "praise",
    "pranab",
    "prasad",
    "prashant",
    "pratap",
    "pratt",
    "pravin",
    "prayer",
    "precious",
    "predator",
    "prelude",
    "premier",
    "presence",
    "present",
    "president",
    "president1",
    "president123",
    "presidentpass",
    "presidentpresident",
    "press",
    "press1",
    "press123",
    "presspass",
    "presspress",
    "presto",
    "preston",
    "pretty",
    "prettyface",
    "prevision",
    "price",
    "primus",
    "prince",
    "princess",
    "princeton",
    "print",
    "print123",
    "printemps",
    "printer",
    "printing",
    "prisca",
    "priv",
    "privacy",
    "privacy1",
    "privacy123",
    "privacypass",
    "privacyprivacy",
    "private",
    "privs",
    "producers",
    "production",
    "production1",
    "production123",
    "productionpass",
    "productionproduction",
    "prof",
    "prof.",
    "professor",
    "profile",
    "program",
    "programming",
    "programming1",
    "programming123",
    "programmingpass",
    "project",
    "project1",
    "promethe",
    "prometheus",
    "promotions",
    "promotions1",
    "promotions123",
    "promotionspass",
    "promotionspromotions",
    "pronghorn",
    "property",
    "prosper",
    "protect",
    "protel",
    "protocol",
    "protocolo",
    "protozoa",
    "provider",
    "proxy",
    "proxy123",
    "prpass",
    "prpr",
    "prudence",
    "prueba",
    "prueba1",
    "prueba123",
    "prueba2",
    "prueba3",
    "ps",
    "psalms",
    "p@ssw0rd",
    "p@ssw0rd!",
    "p@ssw0rd1",
    "p@ssw0rd123",
    "p@ssword",
    "p@ssword123",
    "psybnc",
    "psycho",
    "pub",
    "public",
    "publicity",
    "publicity1",
    "publicity123",
    "publicitypass",
    "publicitypublicity",
    "publisher",
    "publisher1",
    "publisher123",
    "publisherpass",
    "publisherpublisher",
    "pubus",
    "puckett",
    "puddin",
    "pulamea",
    "pule",
    "pull",
    "pulsar",
    "pumkinpie",
    "pumpkin",
    "puneet",
    "punish9899",
    "punkin",
    "pup",
    "puppet",
    "puppies",
    "puppy",
    "puppy123",
    "purnendu",
    "purple",
    "purple123",
    "pussy",
    "pussy1",
    "put",
    "pvm",
    "pvm123",
    "p@$$w0rd",
    "pwrchute",
    "pwrchute123",
    "pyramid",
    "pyro",
    "python",
    "q0tsrbv488",
    "q1w2e3",
    "q1w2e3r4",
    "q1w2e3r4t5",
    "q1w2e3r4t5y6",
    "q1w2e3r4t5y6u7i8o9p0",
    "q2w3e4r5",
    "qawsed",
    "qaz",
    "qaz123",
    "qaz12wsx",
    "!qaz2wsx",
    "!qaz2wsx#edc",
    "qazwsx",
    "!qaz@wsx",
    "qazwsx123",
    "qazwsxedc",
    "qazwsxedcrfv",
    "qazwsxedcrfvtgbyhnum",
    "qazxsw",
    "!qazxsw@",
    "!qazxsw2",
    "qed",
    "qian",
    "qinsong",
    "qmaill",
    "qmailp",
    "qmailq",
    "qmailr",
    "qmails",
    "qpoeiruty",
    "qpwoeiruty",
    "qq123456",
    "qqq",
    "qqq111",
    "qqqq",
    "qqqqq",
    "qqqqqq",
    "qqqqqqq",
    "qqqqqqqq",
    "qsxesz",
    "qti7zxh18u",
    "quality",
    "quebec",
    "queen",
    "queenie",
    "quentin",
    "querty",
    "quest",
    "questions",
    "questions1",
    "questions123",
    "questionspass",
    "questionsquestions",
    "quoc",
    "!q@w",
    "qw1er2ty3",
    "qwaszx",
    "qwe123",
    "qweasdzxc",
    "qweqwe123",
    "qwer",
    "qwer1234",
    "!@#$qwerasdf",
    "qwert",
    "qwert12345",
    "qwerty",
    "qwerty12",
    "qwerty123",
    "qwerty1234",
    "qwertyu",
    "qwertyui",
    "qwertyuiop",
    "qwertyuiop[]",
    "qwerzxcv",
    "qwpoeriuty",
    "r00t",
    "r00t123",
    "r00tr00t",
    "r00ts",
    "r0ger",
    "r0ot",
    "r0x1ng",
    "r2d2",
    "r3dh@t",
    "r3nt4l",
    "r9lw4j8khx",
    "rabbit",
    "rabbit1",
    "racer",
    "racerx",
    "raceweb",
    "rachel",
    "rachelle",
    "rachmaninoff",
    "racing",
    "racoon",
    "radar",
    "radha",
    "radhat",
    "radhat6",
    "radhat7",
    "radhat8",
    "radhat9",
    "radio",
    "rafael",
    "raffi",
    "rafiki",
    "raghav",
    "raghavan",
    "raghu",
    "ragunath",
    "raid",
    "raider",
    "raiders",
    "raidersofthelostark",
    "raimund",
    "rain",
    "rainbow",
    "raindrop",
    "raissa",
    "raistlin",
    "raj",
    "raja",
    "rajadasa",
    "rajeeb",
    "rajeev",
    "rajendra",
    "rajiv",
    "rakesh",
    "raleigh",
    "ralph",
    "ram",
    "ramachan",
    "ramana",
    "ramani",
    "ramarao",
    "rambo",
    "rambo1",
    "rameaux",
    "ramesh",
    "ramirez",
    "ramon",
    "ran",
    "rancid",
    "randal",
    "randall",
    "randi",
    "randolph",
    "random",
    "randy",
    "randy1",
    "randy123",
    "randypass",
    "randyrandy",
    "ranger",
    "rangers",
    "ranjan",
    "ranjith",
    "raoul",
    "rap",
    "raptor",
    "raquel",
    "rascal",
    "rasika",
    "raspberry",
    "rasta",
    "rasta1",
    "rastafarian",
    "rastaman",
    "rat",
    "ratio",
    "raul27m",
    "raven",
    "ravens",
    "ravi",
    "ray",
    "raymona",
    "raymond",
    "read",
    "reader",
    "reading",
    "reagan",
    "real",
    "realestate",
    "realestate1",
    "realestate123",
    "realestatepass",
    "realestaterealestate",
    "realfriend",
    "reality",
    "really",
    "realthing",
    "realtime",
    "rebecca",
    "rebels",
    "reboot",
    "recruit",
    "red",
    "red123",
    "redbaron",
    "redbrick",
    "redcloud",
    "reddog",
    "redfish",
    "redhat",
    "redhat123",
    "redline",
    "redman",
    "redrum",
    "redskin",
    "redskins",
    "redwing",
    "redwood",
    "reebok",
    "reed",
    "reefer",
    "reg",
    "reggae",
    "reggie",
    "regina",
    "reginald",
    "regional",
    "regis",
    "reine",
    "reliant",
    "remember",
    "remi",
    "remote",
    "remove",
    "remove1",
    "remove123",
    "removepass",
    "removeremove",
    "remy",
    "renaud",
    "renault",
    "rene",
    "renee",
    "renegade",
    "rengaraj",
    "rental",
    "rentals",
    "rentals1",
    "rentals123",
    "rentalspass",
    "rentalsrentals",
    "replicant",
    "repoman",
    "reponse",
    "reptile",
    "republic",
    "request",
    "request1",
    "request123",
    "requestpass",
    "requestrequest",
    "requin",
    "rescue",
    "research",
    "research1",
    "research123",
    "researchpass",
    "researchresearch",
    "reseau",
    "reseller",
    "reseller1",
    "reseller123",
    "resellerpass",
    "resellerreseller",
    "reservations",
    "reservations1",
    "reservations123",
    "reservationspass",
    "reserve",
    "reserve1",
    "reserve123",
    "reservepass",
    "reservereserve",
    "restart",
    "resu",
    "retard",
    "returns",
    "returns1",
    "returns123",
    "returnspass",
    "returnsreturns",
    "revolution",
    "rewt",
    "rex",
    "rexmen",
    "reynolds",
    "reza",
    "reznor",
    "rfs",
    "rfv",
    "rfvcde",
    "rhett",
    "rhino",
    "rhjrjlbk",
    "rhona",
    "rhonda",
    "riacs",
    "ribs",
    "ricardo",
    "ricardo1",
    "riccardo",
    "rich",
    "rich1",
    "rich123",
    "richard",
    "richard1",
    "richard123",
    "richardpass",
    "richardrichard",
    "richards",
    "richardson",
    "richmond",
    "richpass",
    "richrich",
    "rick",
    "rick1",
    "rick123",
    "ricki",
    "rickpass",
    "rickrick",
    "ricky",
    "riddle",
    "ride",
    "riffraf",
    "riffraff",
    "riff-raff",
    "rifraf",
    "rifraff",
    "right",
    "riley",
    "ringo",
    "ripper",
    "ripple",
    "risc",
    "rit",
    "rita",
    "river",
    "rivera",
    "rivi",
    "rje",
    "rjgo7we138",
    "ro0t",
    "ro0ttri!10bites",
    "road",
    "roadrunner",
    "roadwarrior",
    "road warrior",
    "rob",
    "rob1",
    "rob123",
    "robbie",
    "robby",
    "robert",
    "robert1",
    "robert123",
    "roberta",
    "roberto",
    "robertpass",
    "robertrobert",
    "roberts",
    "robin",
    "robinhoo",
    "robinhood",
    "robinson",
    "robley",
    "robocop",
    "robot",
    "robotech",
    "robotics",
    "robpass",
    "robrob",
    "robyn",
    "roche",
    "rochelle",
    "rochester",
    "rock",
    "rocket",
    "rocket1",
    "rockie",
    "rocknroll",
    "rockon",
    "rocky",
    "rocky1",
    "rockyhorror",
    "rocky horror",
    "rod",
    "rodent",
    "rodeo",
    "rodger",
    "rodman",
    "rodney",
    "rodolphe",
    "rodrigue",
    "rodriguez",
    "roger",
    "roger1",
    "roger123",
    "rogerpass",
    "rogerroger",
    "rogers",
    "rohit",
    "roi",
    "rokny",
    "roland",
    "rolande",
    "rolex",
    "rolidex",
    "rollin",
    "rom",
    "romain",
    "roman",
    "romania",
    "romanian",
    "romano",
    "romaric",
    "romeo",
    "rommel",
    "romuald",
    "romulan",
    "romulans",
    "romy",
    "ron",
    "ron1",
    "ron123",
    "ronak",
    "ronald",
    "ronen",
    "roni",
    "ronin",
    "ronitt",
    "ronpass",
    "ronron",
    "rookie",
    "rooster",
    "root",
    "root~!@",
    "root!",
    "root!@#",
    "root!@#$",
    "root#",
    "root0",
    "root00",
    "root01",
    "root0987654321",
    "root1",
    "root10",
    "root12",
    "root123",
    "root@123",
    "root1234",
    "root12345",
    "root123456",
    "root1234567890",
    "root2",
    "root21",
    "root3",
    "root321",
    "root4",
    "root4321",
    "root5",
    "root54321",
    "root6",
    "root7",
    "root8",
    "root9",
    "rootabc",
    "rootadmin",
    "rootadministrator",
    "rootbeer",
    "rootkit",
    "rootme",
    "rootpass",
    "rootroot",
    "rootrootroot",
    "roots",
    "rootuser",
    "rootx",
    "roping",
    "rosa",
    "rosalie",
    "rose",
    "rosebud",
    "roseline",
    "rosemary",
    "roses",
    "rosie",
    "rosine",
    "ross",
    "rossigno",
    "roth",
    "rouge",
    "rough",
    "roulette",
    "round",
    "route66",
    "router",
    "roxana",
    "roxy",
    "roy",
    "royal",
    "royals",
    "rpc",
    "rpc123",
    "rpcuser",
    "rpcuser123",
    "rpm",
    "rpm123",
    "rrr",
    "rrrr",
    "rrrrr",
    "rrrrrr",
    "rrrrrrr",
    "rrrrrrrr",
    "rsm",
    "r@@t",
    "rti",
    "rtorres",
    "rtwo",
    "rtwodtwo",
    "ruben",
    "ruby",
    "ruchohco888",
    "rudolf",
    "rudy",
    "ruey",
    "rufus",
    "rugby",
    "ruger40",
    "rugger",
    "ruggieri",
    "ruknet",
    "rules",
    "run",
    "runner",
    "running",
    "ruoxin",
    "rush",
    "rush2112",
    "russ",
    "russel",
    "russell",
    "rusticos",
    "rusticos123",
    "rusty",
    "ruth",
    "ruthie",
    "ruthless",
    "rux",
    "ruy",
    "ruye",
    "ryan",
    "ryohei",
    "ryota",
    "rzx!@!*baizhao",
    "s",
    "s0l@r1s",
    "s0urc3",
    "s1lv3r",
    "s3arch",
    "s50b32",
    "saab",
    "saab900",
    "saab9000",
    "saabturbo",
    "sabbath",
    "sabina",
    "sabine",
    "sabrina",
    "sacre",
    "sad",
    "sade",
    "sadie",
    "safaa",
    "safetp",
    "safety",
    "safety1",
    "safwat",
    "sagittaire",
    "sai",
    "said",
    "saifalla",
    "saigon",
    "saikumar",
    "sailing",
    "sailor",
    "saint",
    "sainte",
    "sakti",
    "sakura",
    "sal",
    "sal9000",
    "salah",
    "salasana",
    "sales",
    "sales1",
    "sales123",
    "salespass",
    "salessales",
    "salle",
    "sally",
    "salmon",
    "salome",
    "salone",
    "salut",
    "sam",
    "sam1",
    "sam123",
    "samadams",
    "samantha",
    "samba",
    "samba123",
    "sambaserver",
    "samedi",
    "samiam",
    "samir",
    "sammie",
    "sammy",
    "sampass",
    "sampath",
    "sample",
    "sampler",
    "sampson",
    "samsam",
    "samson",
    "samsung",
    "samtaney",
    "samuel",
    "samurai",
    "sanchez",
    "sanders",
    "sanderson",
    "sandgorg",
    "sandi",
    "sandra",
    "sandra1",
    "sandra123",
    "sandrapass",
    "sandrasandra",
    "sandrine",
    "sandsmmx",
    "sandy",
    "sandy123",
    "sanfran",
    "sanfrancisco",
    "sang",
    "sangbang",
    "sango",
    "sanh",
    "sani",
    "sanjay",
    "sanjeev",
    "sanjose",
    "sanjose1",
    "santa",
    "santiago",
    "santisuk",
    "santo",
    "sapdb",
    "saphire",
    "sapphire",
    "sara",
    "sara2000",
    "sarah",
    "sarah1",
    "sarah123",
    "sarahpass",
    "sarahsarah",
    "saroj",
    "sasha",
    "sasha123",
    "sashi",
    "saskia",
    "sassy",
    "satori",
    "saturday",
    "saturn",
    "saturn5",
    "saturne",
    "saturnin",
    "saul",
    "sauvignon",
    "savafr3kingat",
    "savage",
    "save",
    "sawedoff",
    "saxon",
    "say",
    "saypl3as3",
    "sayplease",
    "sbdc",
    "sbear",
    "scamper",
    "scarecrow",
    "scarlet",
    "scarlett",
    "scheme",
    "schnapps",
    "school",
    "schroede",
    "science",
    "sciubba",
    "scooby",
    "scoobydoo",
    "scooter",
    "scooter1",
    "scorpio",
    "scorpion",
    "scot",
    "scotch",
    "scott",
    "scott1",
    "scott123",
    "scottie",
    "scottpass",
    "scottscott",
    "scotty",
    "scout",
    "scouts",
    "scream",
    "scricideea",
    "scrofula",
    "scrooge",
    "scruffy",
    "scuba",
    "scuba1",
    "scumbag",
    "sdfghjkl",
    "sea",
    "seabreeze",
    "sean",
    "sean1",
    "sean123",
    "seanpass",
    "seansean",
    "search",
    "seattle",
    "sebastien",
    "sechang",
    "secret",
    "secret3",
    "securesites",
    "security",
    "security1",
    "security123",
    "securitypass",
    "securitysecurity",
    "see",
    "seeker",
    "seeme",
    "seho",
    "sei",
    "seifer",
    "seifer1",
    "seifer123",
    "seiferpass",
    "seiferseifer",
    "seigneur",
    "seive",
    "sekhar",
    "select",
    "selftime",
    "semperfi",
    "senaka",
    "senator",
    "senator1",
    "senator123",
    "senatorpass",
    "senatorsenator",
    "send",
    "senderkw",
    "sending",
    "sendit",
    "sendmail",
    "sendmail1",
    "sendmail123",
    "sendmailpass",
    "sendmailsendmail",
    "senior",
    "sensor",
    "seonghoo",
    "seoul",
    "septembe",
    "september",
    "septembre",
    "sequent",
    "serena",
    "serenity",
    "serge",
    "sergei",
    "sergey",
    "server",
    "server1",
    "server123",
    "service",
    "service1",
    "service123",
    "servicepass",
    "services",
    "serviceservice",
    "servidor",
    "sesame",
    "sesamestreet",
    "seth",
    "setup",
    "setup123",
    "seung",
    "seunghyu",
    "seungku",
    "sevak",
    "seven",
    "seven7",
    "severin",
    "sex",
    "sexfiend",
    "sexxxme",
    "sexy",
    "sexyteen",
    "seymour",
    "sh3i5lik3p4rty@v3r",
    "sh3llb0x",
    "shadow",
    "shadow1",
    "shadows",
    "shadyside",
    "shae",
    "shaggy",
    "shahrokh",
    "shakespeare",
    "shall",
    "shalom",
    "shamita",
    "shan",
    "shana",
    "shanghai",
    "shannan",
    "shannon",
    "shanny",
    "shantanu",
    "shanti",
    "shaolin",
    "sharad",
    "sharc",
    "share",
    "share123",
    "shari",
    "shariyn",
    "shark",
    "sharks",
    "sharlene",
    "sharon",
    "sharra",
    "shashank",
    "shashi",
    "shasta",
    "shaun",
    "shaved",
    "shaven",
    "shaw",
    "shawn",
    "shayne",
    "shazam",
    "shazzam",
    "she",
    "sheba",
    "sheela",
    "sheena",
    "sheffield",
    "sheila",
    "shel",
    "shelby",
    "sheldon",
    "shelia",
    "shell",
    "shell123",
    "shelley",
    "shelly",
    "shelter",
    "shelton",
    "shen",
    "sheng",
    "shenglu",
    "shepherd",
    "sherif",
    "sherri",
    "sherrie",
    "sherry",
    "sheryl",
    "shi",
    "shiahn",
    "shidan",
    "shigenar",
    "shigeo",
    "shih",
    "shihming",
    "shimon",
    "shin",
    "shinobu",
    "ship",
    "shipping",
    "shipping1",
    "shipping123",
    "shippingpass",
    "shippingshipping",
    "shirin",
    "shirl",
    "shirley",
    "shit",
    "shitfaced",
    "shitforbrains",
    "shithead",
    "shit-head",
    "shiue",
    "shiva",
    "shivapra",
    "shivers",
    "shizoom",
    "shlee",
    "shlomo",
    "shoes",
    "shogun",
    "sholom",
    "shomita",
    "shooter",
    "shop",
    "shop1",
    "shop123",
    "shoppass",
    "shopping",
    "shopshop",
    "shorty",
    "shotgun",
    "shout",
    "show",
    "shower",
    "showoff",
    "shrdlu",
    "shreeram",
    "shu",
    "shuang",
    "shuhui",
    "shun",
    "shuri",
    "shutdown",
    "shuttle",
    "shyng",
    "si1v3r",
    "sid",
    "sidarta",
    "sidekick",
    "sidharta",
    "sidney",
    "sidoine",
    "siemens",
    "sierra",
    "sigmachi",
    "signal",
    "signature",
    "silence",
    "sillywalk",
    "silver",
    "silvere",
    "silvia",
    "sim",
    "sim123",
    "simba",
    "simba1",
    "simmons",
    "simon",
    "simple",
    "simple123",
    "simply",
    "simpson",
    "simpsons",
    "simsim",
    "simulation",
    "simulation123",
    "simulator",
    "sina",
    "sinatra",
    "sing",
    "singer",
    "single",
    "siobahn",
    "sirakiya",
    "siri",
    "sirius",
    "sirsi",
    "sistemas",
    "sister",
    "sit",
    "site",
    "siteinfo",
    "siteinfo1",
    "siteinfo123",
    "siteinfopass",
    "siteinfositeinfo",
    "siuping",
    "sivakuma",
    "six",
    "sixtynine",
    "sizenine",
    "skaner",
    "skate",
    "skater",
    "skeeter",
    "skibum",
    "skidoo",
    "skiing",
    "skinny",
    "skip",
    "skipper",
    "skipper1",
    "skippy",
    "skull",
    "skunk",
    "sky",
    "skydive",
    "skyler",
    "skyrix",
    "skywalker",
    "slacker",
    "slaw",
    "slayer",
    "sleazy",
    "sleep",
    "sleepy",
    "slick",
    "slider",
    "slimeball",
    "slinky",
    "slip",
    "slus",
    "slut",
    "small",
    "smallcock",
    "smallhips",
    "smalltalk",
    "smalltips",
    "smart",
    "smart123",
    "smartlist",
    "smashed",
    "smashing",
    "smbuser",
    "smbuser123",
    "smegma",
    "smile",
    "smile1",
    "smiles",
    "smiley",
    "smith",
    "smiths",
    "smitty",
    "smmsp",
    "smmsp123",
    "smoke",
    "smokedham",
    "smokey",
    "smooch",
    "smother",
    "smurfy",
    "smut",
    "snaffu",
    "snafoo",
    "snafu",
    "snake",
    "snakes",
    "snappel",
    "snapper",
    "snapple",
    "snatch",
    "sneezy",
    "snell",
    "snfau",
    "snicker",
    "snickers",
    "sniper",
    "snoop",
    "snoopdog",
    "snoopy",
    "snoopy1",
    "snorkydorky",
    "snow",
    "snowbal",
    "snowball",
    "snowflake",
    "snowing",
    "snowman",
    "snowski",
    "snuffy",
    "so",
    "soap",
    "sober1",
    "sobysoricelu",
    "soccer",
    "soccer1",
    "soccor",
    "socha",
    "socrate",
    "socrates",
    "sod",
    "sodoff",
    "sod off",
    "soft",
    "softball",
    "software",
    "soigan",
    "sojdlg123aljg",
    "solange",
    "solo",
    "soleil",
    "soloman",
    "solomon",
    "soman",
    "somasama",
    "sombrero",
    "some",
    "somebody",
    "someone",
    "someone1",
    "someone123",
    "someonepass",
    "someonesomeone",
    "son",
    "sondra",
    "songmiao",
    "songnian",
    "sonia",
    "sonic",
    "sonic15gs",
    "sonics",
    "sonja",
    "sonny",
    "sony",
    "sonya",
    "soon",
    "soonman",
    "soowon",
    "sophia",
    "sophie",
    "sophomore",
    "soporte",
    "sorel",
    "soroor",
    "sossina",
    "sotiris",
    "soua",
    "soumitra",
    "sound",
    "source",
    "sourire",
    "souris",
    "sourmilk",
    "south",
    "souvenir",
    "space",
    "spaceman",
    "spain",
    "spam",
    "spam1",
    "spam123",
    "spamd",
    "spampass",
    "spamspam",
    "spanish",
    "spanky",
    "sparc",
    "sparks",
    "sparky",
    "sparrow",
    "sparrows",
    "spartan",
    "spazz",
    "special",
    "specter",
    "spectre",
    "speech",
    "speed",
    "speedo",
    "speedy",
    "spence",
    "spencer",
    "sph",
    "sphynx",
    "spice",
    "spider",
    "spiderman",
    "spiff",
    "spiffy",
    "spike",
    "spike1",
    "spirit",
    "spiritu",
    "spiritusanctu",
    "spiro",
    "spiros",
    "spit",
    "spitfire",
    "splif",
    "spliff",
    "spm4!you",
    "spock",
    "sponge",
    "sponsor",
    "sponsor1",
    "sponsor123",
    "sponsorpass",
    "sponsorsponsor",
    "spooky",
    "spooler",
    "spoon",
    "sport",
    "sports",
    "sports1",
    "sports123",
    "sportspass",
    "sportssports",
    "spot",
    "sprang",
    "spring",
    "springer",
    "sprite",
    "sprocket",
    "spud",
    "spunky",
    "spurs",
    "spyrogyra",
    "spyros",
    "squash",
    "squid",
    "squid123",
    "squires",
    "squirrelmail",
    "squirrelmail123",
    "squirt",
    "src",
    "sridhar",
    "srimat",
    "srinivas",
    "sshd",
    "sshd123",
    "sshdaccess",
    "ssi",
    "ssi1",
    "ssi123",
    "ssipass",
    "ssissi",
    "sss",
    "ssss",
    "sssss",
    "ssssss",
    "sssssss",
    "ssssssss",
    "ssu",
    "stacey",
    "staci",
    "stacie",
    "stacy",
    "staff",
    "staff1",
    "staff123",
    "staffpass",
    "staffstaff",
    "stage",
    "stainless",
    "stalker",
    "stamos",
    "stan",
    "stanislas",
    "stanley",
    "stanly",
    "stanton",
    "star",
    "star69",
    "starbuck",
    "stargate",
    "starlight",
    "stars",
    "starship",
    "start",
    "starter",
    "startrek",
    "startx",
    "starwars",
    "star wars",
    "stat",
    "state",
    "states",
    "station",
    "stats",
    "stats123",
    "status",
    "stay",
    "stay1",
    "stay123",
    "staypass",
    "staystay",
    "stdr2300",
    "stealth",
    "steel",
    "steele",
    "steelers",
    "stefan",
    "stefano",
    "stella",
    "stemple",
    "steph",
    "steph1",
    "stephane",
    "stephani",
    "stephanie",
    "stephanie1",
    "stephanie123",
    "stephaniepass",
    "stephaniestephanie",
    "stephany",
    "stephen",
    "stephi",
    "stephon",
    "sterling",
    "stern93",
    "steve",
    "steve1",
    "steve123",
    "steven",
    "steven1",
    "stevens",
    "stevepass",
    "stever",
    "stevesteve",
    "stewart",
    "stickshift",
    "stiffdrink",
    "stiffprick",
    "stimpy",
    "stimulate",
    "sting",
    "sting1",
    "stingray",
    "stinky",
    "stivers",
    "stocks",
    "stone",
    "stones",
    "stop",
    "storage",
    "storem",
    "storm",
    "stormy",
    "strange",
    "stranger",
    "strangle",
    "strat",
    "stratford",
    "strato",
    "stratocaster",
    "strawber",
    "strawberry",
    "stretch",
    "strider",
    "strong",
    "sttng",
    "stu",
    "stuart",
    "stud",
    "student",
    "student123",
    "student1234",
    "student2",
    "studentaccount",
    "students",
    "students123",
    "students1234",
    "studentsaccount",
    "studfuck",
    "studio",
    "studly",
    "stuffed",
    "stuffedturkey",
    "stumpy",
    "stup1db0x",
    "stupid",
    "stuttgart",
    "su",
    "subdomain",
    "subdomain1",
    "subdomain123",
    "subdomainpass",
    "subdomainsubdomain",
    "subgenius",
    "subhas",
    "subhdail",
    "subhednu",
    "submissions",
    "submissions1",
    "submissions123",
    "submissionspass",
    "submit",
    "submit1",
    "submit123",
    "submitpass",
    "submitsubmit",
    "subodh",
    "subscribe",
    "subscribe1",
    "subscribe123",
    "subscribepass",
    "subscriber",
    "subscribesubscribe",
    "subscriptions",
    "subscriptions1",
    "subscriptions123",
    "subscriptionspass",
    "subway",
    "succes",
    "success",
    "suck",
    "sucker",
    "suckme",
    "suckrocks",
    "sucks",
    "sudeshna",
    "sudhakar",
    "sudhir",
    "sudir",
    "sue",
    "suesec",
    "sugar",
    "sugarbear",
    "suggest",
    "suggest1",
    "suggest123",
    "suggestpass",
    "suggestsuggest",
    "sugih",
    "sukumar",
    "sultan",
    "sulu",
    "summer",
    "summit",
    "sumuinen",
    "sun",
    "sun0s",
    "sun123",
    "sunbird",
    "sundance",
    "sunday",
    "sunfire",
    "sunflowe",
    "sunflower",
    "sung",
    "sunh1n3",
    "sunil",
    "sunny",
    "sunny1",
    "sunnyvale",
    "sunos",
    "sunr1s3",
    "sunrise",
    "sunset",
    "sunshin",
    "sunshine",
    "sun-spot",
    "suntools",
    "sunwei",
    "super",
    "super1or",
    "superfly",
    "superman",
    "superstage",
    "superstar",
    "superuser",
    "supervisor",
    "suporte",
    "support",
    "support1",
    "support123",
    "supported",
    "supportpass",
    "supportsupport",
    "supra",
    "suranet",
    "suresh",
    "surf",
    "surfer",
    "surfing",
    "sus",
    "susan",
    "susan1",
    "susan123",
    "susanna",
    "susanne",
    "susanpass",
    "susansusan",
    "suse",
    "susha",
    "sushila",
    "susie",
    "sutton",
    "suvendu",
    "suvro",
    "suzanna",
    "suzanne",
    "suzie",
    "suzuki",
    "suzy",
    "sven",
    "sverige",
    "svn",
    "sw0rdf1sh",
    "swamprat",
    "swane",
    "swanson",
    "swdefr",
    "swearer",
    "sweatshop",
    "sweden",
    "sweetie",
    "sweetnes",
    "sweetpea",
    "sweets",
    "sweety",
    "swim",
    "swimmer",
    "swimming",
    "swingset",
    "switzer",
    "swoosh",
    "swordfish",
    "swsoft",
    "syam",
    "sybase",
    "sybase123",
    "sybil",
    "sydney",
    "sylvain",
    "sylvere",
    "sylveste",
    "sylvestre",
    "sylvia",
    "sylvie",
    "symbol",
    "symmetry",
    "symult",
    "sync",
    "sync123",
    "synopass",
    "syphilis",
    "syphillis",
    "sys",
    "sys123",
    "sys5",
    "sysadm",
    "sysadmin",
    "sysadmin123",
    "sysdiag",
    "sysdiags",
    "sysguest",
    "syslib",
    "sysmail",
    "sysmaint",
    "sysman",
    "sysmgr",
    "sysop",
    "sysroot",
    "system",
    "system5",
    "systemadmin",
    "systemfive",
    "systemv",
    "systest",
    "sysuser",
    "sysv",
    "t",
    "t0nyd@nz@",
    "t0talc0ntr0l4!",
    "t120",
    "t35tm3",
    "t3st",
    "t3st3r",
    "t3stm3",
    "tab",
    "tabatha",
    "tacobell",
    "tadahiro",
    "tadlock",
    "taffy",
    "tai",
    "taiwan",
    "tajen",
    "tak",
    "taka",
    "takada",
    "takaji",
    "takashi",
    "take",
    "take5",
    "takefive",
    "takeiteasy",
    "takuji",
    "talent",
    "talon",
    "tam",
    "tamal",
    "tamara",
    "tamas",
    "tami",
    "tamie",
    "tammie",
    "tammy",
    "tamtam",
    "tandy",
    "tangerine",
    "tango",
    "tanguy",
    "tania",
    "tanju",
    "tanker",
    "tanner",
    "tanya",
    "tao",
    "tapani",
    "tapas",
    "tape",
    "tar",
    "tara",
    "tardis",
    "targas",
    "target",
    "tarheel",
    "tarragon",
    "tarzan",
    "tasha",
    "tata",
    "tatiana",
    "tatsuo",
    "tattoo",
    "tatum",
    "taureau",
    "taurus",
    "tayfur",
    "taylor",
    "tazdevil",
    "tazman",
    "tazmania",
    "tbird",
    "t-bone",
    "tchen",
    "tcpip",
    "tcp-ip",
    "tcp/ip",
    "</td></tr>",
    "teacher",
    "teachers",
    "teakettle",
    "teaparty",
    "tear",
    "tech",
    "tech1",
    "tech123",
    "techit",
    "techit123",
    "technical",
    "techno",
    "technology",
    "techpass",
    "techsupport",
    "techsupport1",
    "techsupport123",
    "techsupportpass",
    "techtech",
    "ted",
    "teddi",
    "teddy",
    "teddy1",
    "teddybear",
    "tee",
    "teen",
    "teenager",
    "teeney",
    "teenfan",
    "teeny",
    "teflon",
    "telecast",
    "telecom",
    "telephone",
    "tell",
    "telnet",
    "telnet1",
    "telnet123",
    "telnetd",
    "telnetd123",
    "telnetpass",
    "telnettelnet",
    "temp",
    "temp1",
    "temp123",
    "temp1234",
    "temporal",
    "temptation",
    "temptress",
    "ten",
    "tennis",
    "tentation",
    "tequila",
    "teresa",
    "teri",
    "terminal",
    "terre",
    "terri",
    "terrill",
    "terry",
    "terry1",
    "terry123",
    "terrypass",
    "terryterry",
    "test",
    "test1",
    "test10",
    "test11",
    "test1123",
    "test12",
    "test123",
    "test1234",
    "test12345",
    "test123456",
    "test2",
    "test2123",
    "test3",
    "test3123",
    "test4",
    "test4123",
    "test5",
    "test5123",
    "test6",
    "test7",
    "test8",
    "test9",
    "testaccount",
    "testbox",
    "testcase",
    "teste",
    "teste123",
    "tester",
    "tester01",
    "tester123",
    "tester1234",
    "testguy",
    "testi",
    "testimonials",
    "testimonials1",
    "testimonials123",
    "testimonialspass",
    "testing",
    "testing123",
    "testing1234",
    "testm3",
    "testmail",
    "testme",
    "testpass",
    "testtest",
    "testuser",
    "tetiro34",
    "tetris",
    "tetsuo",
    "tex",
    "texas",
    "tftper",
    "tgb",
    "tgif",
    "thaddeus",
    "thailand",
    "thailande",
    "than",
    "thanasis",
    "thanh",
    "thank",
    "thankgod",
    "thankyou",
    "that",
    "thatcher",
    "thavy",
    "the",
    "theatre",
    "thebeef",
    "thebest",
    "thebirds",
    "theboss",
    "thebutler",
    "thecle",
    "theend",
    "thegreat123",
    "thegreatescape",
    "their",
    "thejudge",
    "theking",
    "thekingandi",
    "thelorax",
    "them",
    "theman",
    "themonkey",
    "then",
    "theodora",
    "theodore",
    "theophile",
    "thepenguin",
    "theproducers",
    "there",
    "therealthing",
    "theresa",
    "therese",
    "theriddler",
    "theron",
    "these",
    "they",
    "thiam",
    "thibault",
    "thibaut",
    "thickcock",
    "thickhead",
    "thickskin",
    "thierry",
    "thilaka",
    "think",
    "thinthighs",
    "this",
    "thisisit",
    "thoi",
    "thomas",
    "thompson",
    "thomson",
    "thorne",
    "thorsten",
    "those",
    "thrasher",
    "three",
    "thu",
    "thumper",
    "thunder",
    "thunderb",
    "thunderball",
    "thunderbird",
    "thunderdome",
    "thursday",
    "thuy",
    "thx1138",
    "tian",
    "tiffany",
    "tiger",
    "tiger2",
    "tigers",
    "tigger",
    "tightass",
    "tightcunt",
    "tightend",
    "tightfit",
    "tigre",
    "tijun",
    "tika",
    "till",
    "tim",
    "tim1",
    "tim123",
    "timber",
    "time",
    "timezone",
    "timothy",
    "timpass",
    "timtim",
    "tina",
    "ting",
    "tinker",
    "tinkerbell",
    "tinman",
    "tintin",
    "tireswing",
    "titanic",
    "tits",
    "tivoli",
    "tivoli123",
    "tiw",
    "tiziano",
    "tjahjadi",
    "tmp",
    "tmp123",
    "tneduts",
    "tnt",
    "to",
    "tobias",
    "toby",
    "tod",
    "today",
    "todd",
    "together",
    "toggle",
    "tohru",
    "tokyo",
    "tolkein",
    "tolkien",
    "tom",
    "tom1",
    "tom123",
    "tomas",
    "tomaso",
    "tomate",
    "tomato",
    "tomcat",
    "tomcat123",
    "tomcat4",
    "tomcat5",
    "tommy",
    "tompass",
    "tomtom",
    "tone",
    "toni",
    "tony",
    "tony1",
    "tony123",
    "tonypass",
    "tonytony",
    "too",
    "tool",
    "toor",
    "toor123",
    "toor1234",
    "tooraccount",
    "toortoor",
    "toosilly",
    "tootsie",
    "top",
    "topcat",
    "topgun",
    "topher",
    "topic",
    "topography",
    "tor",
    "torc",
    "tornado",
    "toronto",
    "torres",
    "torsten",
    "tortoise",
    "tortue",
    "toshiaki",
    "toshiba",
    "toshiter",
    "tosnow",
    "total",
    "tothedark",
    "toto",
    "toto1",
    "tototo",
    "toucan",
    "toufic",
    "tour",
    "toussaint",
    "tove",
    "toxic",
    "toy",
    "toyota",
    "toysrus",
    "traci",
    "tracie",
    "tracker",
    "tractor",
    "tracy",
    "trailblazer",
    "trailer",
    "trails",
    "training",
    "training1",
    "training123",
    "trainingpass",
    "trainingtraining",
    "trambuline",
    "tran",
    "transexual",
    "transfer",
    "transfiguration",
    "transit",
    "transmit",
    "transport",
    "trapdoor",
    "trapper",
    "trash",
    "trashcan",
    "travail",
    "travel",
    "travis",
    "tre",
    "treasure",
    "trebor",
    "tree",
    "trees",
    "trek",
    "trent",
    "trevor",
    "tri",
    "trial",
    "tribble",
    "tribbles",
    "tricia",
    "tricky",
    "trident",
    "trieu",
    "trina",
    "trinity",
    "trish",
    "trisha",
    "tristan",
    "triton",
    "triumf",
    "trivial",
    "trixie",
    "troff",
    "trojan",
    "trombone",
    "tron",
    "trophy",
    "trouble",
    "trout",
    "troy",
    "truc",
    "truck",
    "trucker",
    "trucks",
    "truefriend",
    "truelove",
    "truman",
    "trumpet",
    "trustno1",
    "try",
    "trya",
    "tryandguessthis",
    "tryth1s",
    "trythis",
    "ts",
    "tse",
    "tset",
    "tseug",
    "tsing",
    "tsingtao",
    "tsing tao",
    "tsing-tao",
    "tsung",
    "tsutomu",
    "ttt",
    "tttt",
    "ttttt",
    "tttttt",
    "ttttttt",
    "tttttttt",
    "tty",
    "tty123",
    "tuan",
    "tuba",
    "tubas",
    "tucker",
    "tucson",
    "tuesday",
    "tula",
    "tull",
    "tunasalad",
    "tunasandwich",
    "tuomas",
    "turbo",
    "turbo2",
    "turner",
    "turnleft",
    "turnright",
    "turtle",
    "tuttle",
    "tuyen",
    "twat123",
    "tweetheart",
    "tweety",
    "twenex",
    "twila",
    "twins",
    "two",
    "tyler",
    "tyler1",
    "tzi",
    "tzila",
    "tzuwang",
    "ubnt",
    "ubuntu",
    "uday",
    "udo",
    "uhn",
    "uhnsoon",
    "uhn-soon",
    "ujm",
    "uk",
    "uli",
    "ulric",
    "ulrich",
    "ultimate",
    "umesh",
    "ump1r3",
    "un1v3rs3",
    "unclefuckers",
    "undead",
    "undergrad",
    "undergraduate",
    "unguessable",
    "unhackable",
    "unhappy",
    "unicorn",
    "unicos",
    "uniform",
    "unify",
    "unigrafix",
    "unique",
    "united",
    "unity",
    "unix",
    "unixbitch",
    "unixman",
    "unixsuck",
    "unixsux",
    "unix-tounix",
    "unix-to-unix",
    "unknown",
    "unknown123",
    "unkown",
    "unsubscribe",
    "unsubscribe1",
    "unsubscribe123",
    "unsubscribepass",
    "untung",
    "up",
    "upchuck",
    "update",
    "update1",
    "update123",
    "updatepass",
    "updates",
    "updates1",
    "updates123",
    "updatespass",
    "updatesupdates",
    "updateupdate",
    "upload",
    "upload123",
    "upon",
    "upperclass",
    "upsilon",
    "upstill",
    "uptohere",
    "upyours",
    "uq26ppff44",
    "uqa9ebw445",
    "uranus",
    "urbain",
    "urchin",
    "ursula",
    "us",
    "usa",
    "use",
    "usenet",
    "usenix",
    "user",
    "user01",
    "user02",
    "user1",
    "user123",
    "user1234",
    "user123456",
    "user2",
    "useraccount",
    "usermane",
    "username",
    "username1",
    "username123",
    "usernamepass",
    "usernameusername",
    "userpass",
    "userroot",
    "users",
    "useruser",
    "usr",
    "/usr/group",
    "usuario",
    "util",
    "utility",
    "utopia",
    "utpal",
    "uucico",
    "uucp",
    "uucp123",
    "uuu",
    "uuuu",
    "uuuuu",
    "uuuuuu",
    "uuuuuuu",
    "uuuuuuuu",
    "vacation",
    "vacation1",
    "vacation123",
    "vacationpass",
    "vacationvacation",
    "vader",
    "vagrant",
    "vahe",
    "val",
    "valentin",
    "valentine",
    "valerie",
    "valerio",
    "valhalla",
    "valley",
    "vampire",
    "van",
    "vance",
    "vanessa",
    "vanila",
    "vanilla",
    "varkey",
    "vasant",
    "vasanth",
    "vason",
    "vassilio",
    "vaughan",
    "vcsa",
    "vcsa123",
    "vectrex",
    "vectrix",
    "veday",
    "vedder",
    "vee",
    "veljko",
    "velo",
    "velvet",
    "venceslas",
    "vendredi",
    "veneto",
    "venice",
    "venkat",
    "venkatad",
    "venkatar",
    "venkates",
    "venture",
    "venus",
    "ver",
    "verilog",
    "vermont",
    "vernon",
    "veronica",
    "veronique",
    "verseau",
    "vertical@admin123",
    "vertige",
    "vertigo",
    "very",
    "veterans",
    "vette",
    "vh0st",
    "vhbackup",
    "vhbackup1",
    "vhbackup123",
    "vhbackuppass",
    "vhbackupvhbackup",
    "vianney",
    "vibeke",
    "vibhu",
    "vibrator",
    "vic",
    "vicesquad",
    "vicki",
    "vickie",
    "vicky",
    "victoire",
    "victor",
    "victor1",
    "victoria",
    "victorien",
    "victory",
    "video",
    "video1",
    "vierge",
    "view",
    "vigyan",
    "vijay",
    "vijaya",
    "viking",
    "vikings",
    "vikram",
    "villa",
    "village",
    "vilma",
    "vinay",
    "vince",
    "vincent",
    "vincent1",
    "vinit",
    "vinitha",
    "vinod",
    "vinodh",
    "violet",
    "violin",
    "viper",
    "viper1",
    "virago",
    "virgil",
    "virgin",
    "virginbirth",
    "virginia",
    "virginie",
    "virginio",
    "virtualprivateserver",
    "virtuoso",
    "virus",
    "visa",
    "visavis",
    "vishvjit",
    "vision",
    "visit",
    "visitante",
    "visitante123",
    "visitation",
    "visitor",
    "visitor123",
    "vispi",
    "visual",
    "visvanat",
    "vittorio",
    "vivek",
    "vivian",
    "viviane",
    "vivien",
    "vjday",
    "vlad",
    "vlad123",
    "vladimir",
    "vlsi",
    "vm",
    "vms",
    "vmssucks",
    "vmsucks",
    "vmware",
    "vnc",
    "vojin",
    "volcano",
    "volley",
    "volleyb",
    "volvo",
    "voodoo",
    "vortex",
    "voyage",
    "voyager",
    "vpn",
    "vpn123",
    "vpopmail",
    "vpopmail123",
    "vqsablpzla",
    "vscan",
    "vt100",
    "vt52",
    "vvv",
    "vvvv",
    "vvvvv",
    "vvvvvv",
    "vvvvvvv",
    "vvvvvvvv",
    "vwalker",
    "vyatta",
    "w1k1ng5",
    "w1nd0ws",
    "w33k1ngs",
    "w33kings",
    "w3bh0st",
    "w3lc0m3",
    "w5txn36alfw",
    "wa200wma",
    "wade",
    "wai",
    "waiting",
    "walden",
    "waldo",
    "waleed",
    "walid",
    "walk",
    "walker",
    "walleye",
    "wally",
    "walter",
    "wan",
    "wanda",
    "wandojo",
    "wang",
    "wank",
    "wanker",
    "want",
    "wantmenow",
    "warcraft",
    "ward",
    "warez",
    "wargames",
    "warlock",
    "warm",
    "warmweather",
    "warner",
    "warren",
    "warren1",
    "warren123",
    "warrenpass",
    "warrenwarren",
    "warrior",
    "warriors",
    "wars",
    "warthog",
    "was",
    "wash",
    "washington",
    "washingtondc",
    "water",
    "water1",
    "waterloo",
    "watson",
    "waves",
    "way",
    "wayne",
    "wayne1",
    "we",
    "weasel",
    "web",
    "web1",
    "web123",
    "web2",
    "webadm",
    "webadmin",
    "webalizer",
    "webalizer1",
    "webalizer123",
    "webalizerpass",
    "webalizerwebalizer",
    "webbox",
    "webcam",
    "webetoys",
    "webhead",
    "webmaste",
    "webmaster",
    "webmaster1",
    "webmaster123",
    "webmaster1234",
    "webmasterpass",
    "webmasterwebmaster",
    "webpass",
    "webportal",
    "webster",
    "webster1",
    "webster123",
    "websterpass",
    "websterwebster",
    "websupport",
    "websupport1",
    "websupport123",
    "websupportpass",
    "websupportwebsupport",
    "webuser",
    "webweb",
    "wedge",
    "wednesday",
    "weed",
    "weenie",
    "weeny",
    "weezer",
    "wei",
    "weidong",
    "weiheng",
    "weinrich",
    "weiping",
    "welc0me",
    "welch",
    "welcome",
    "welcome1",
    "welcome123",
    "well",
    "welsher",
    "wen",
    "wendel",
    "wendell",
    "wendi",
    "wendy",
    "wendy1",
    "wendy123",
    "wendypass",
    "wendywendy",
    "wengyik",
    "went",
    "were",
    "wes",
    "wesam@200",
    "wesley",
    "west",
    "western",
    "wet",
    "wget",
    "whale1",
    "whales",
    "what",
    "whatchamacallit",
    "whateve",
    "whatever",
    "whatnot",
    "whatsup",
    "whatsupdoc",
    "wheeling",
    "wheels",
    "when",
    "where",
    "whereisthebeef",
    "wheresthebeef",
    "whey",
    "which",
    "whisky",
    "whit",
    "white",
    "whiteley",
    "whiting",
    "whitney",
    "who",
    "whocares",
    "wholesale",
    "whoopie",
    "whoopy",
    "whore",
    "whoville",
    "why",
    "wibble",
    "wicked",
    "wilbur",
    "wildcat",
    "wildchild",
    "wilfried",
    "wilkins",
    "will",
    "willen",
    "william",
    "william1",
    "william123",
    "williampass",
    "williams",
    "williamsburg",
    "williamson",
    "williamwilliam",
    "willie",
    "willow",
    "willy",
    "wilma",
    "wilson",
    "win",
    "win95",
    "wind",
    "window",
    "windows",
    "windsurf",
    "winfred",
    "wing",
    "wingnut",
    "winner",
    "winnie",
    "winniethepooh",
    "winona",
    "winston",
    "winter",
    "wired",
    "wireless",
    "wisconsin",
    "wisdom",
    "wish",
    "with",
    "withdrawals",
    "withdrawals1",
    "withdrawals123",
    "withdrawalspass",
    "witnessfortheprosecution",
    "wizard",
    "wizards",
    "wojtek",
    "wolf",
    "wolf1",
    "wolfgang",
    "wolfman",
    "wolverin",
    "wolverine",
    "wolves",
    "woman",
    "wombat",
    "wombat1",
    "women",
    "won",
    "wonder",
    "wonderboy",
    "wonderbread",
    "wong",
    "wonyun",
    "woobie",
    "woobin",
    "wooby",
    "wood",
    "woodland",
    "woodrow",
    "woodstoc",
    "woodwind",
    "woody",
    "woofwoof",
    "wooiyi",
    "wopperkenny",
    "word",
    "work",
    "workshop",
    "world",
    "wormwood",
    "would",
    "wqsb",
    "wrangler",
    "wrestle",
    "wrestling",
    "wright",
    "write",
    "wsad",
    "wsx",
    "wsxedcrfvtgb",
    "wsxzaq",
    "wubao",
    "wun",
    "wuntsin",
    "www",
    "www1",
    "www123",
    "www-data",
    "www-data123",
    "wwwpass",
    "wwww",
    "wwwww",
    "wwwwww",
    "wwwwwww",
    "wwwwwwww",
    "wxyz",
    "wyldchyd",
    "wynne",
    "wyoming",
    "x",
    "xanadu",
    "xanth",
    "xavier",
    "xaviere",
    "xbox",
    "xcountry",
    "xfer",
    "xfiles",
    "x-files",
    "xfs",
    "xfs123",
    "xgeneration",
    "xi",
    "xiao",
    "xiaobo",
    "xiaogang",
    "xiaoli",
    "xiaomin",
    "xinghao",
    "xinu",
    "xmember",
    "x-men",
    "xmodem",
    "xray",
    "xue",
    "xueqing",
    "xwindows",
    "xxfreessxx",
    "xxpassxx",
    "xxsnowxx",
    "xxx",
    "xxx1",
    "xxx123",
    "xxxpass",
    "xxxx",
    "xxxxx",
    "xxxxxx",
    "xxxxxxx",
    "xxxxxxxx",
    "xyz",
    "xyz123",
    "xyzzy",
    "y",
    "yabba",
    "yabbadabbadoo",
    "yabba-dabba-doo",
    "yaco",
    "yael",
    "yagjecc826",
    "yah00",
    "yahoo",
    "yamaha",
    "yan",
    "yang",
    "yanjun",
    "yankee",
    "yankees",
    "yaomin",
    "yaser",
    "year",
    "yee",
    "yello",
    "yellow",
    "yellowstone",
    "yeng",
    "yeon",
    "yeong",
    "yeti123",
    "yezi",
    "yhn",
    "yiannis",
    "yigal",
    "yihua",
    "yin",
    "ying",
    "yingsha",
    "yingyang",
    "yishun",
    "yoda",
    "yodude",
    "yogesh",
    "yogibear",
    "yoichi",
    "yoko",
    "yolanda",
    "yomama",
    "yon",
    "yonah",
    "yong",
    "yongdong",
    "yongho",
    "yonghwan",
    "yongsam",
    "yosemite",
    "yoshiaki",
    "yoshio",
    "you",
    "you1",
    "you123",
    "youareok",
    "youcef",
    "youhanse",
    "young",
    "youpass",
    "your",
    "youreok",
    "you'reok",
    "yourname",
    "yourname1",
    "yourname123",
    "yournamepass",
    "yournameyourname",
    "yourself",
    "youyou",
    "yuan",
    "yuantuo2012",
    "yuehwern",
    "yugang",
    "yuh",
    "yuji",
    "yujiko",
    "yuka",
    "yukkei",
    "yukon",
    "yumi",
    "yumiko",
    "yung",
    "yuqian",
    "yuval",
    "yves",
    "yvette",
    "yvonne",
    "yyy",
    "yyyy",
    "yyyyy",
    "yyyyyy",
    "yyyyyyy",
    "yyyyyyyy",
    "zabbix",
    "zachary",
    "zack",
    "zap",
    "zapata",
    "zaphod",
    "zaq12wsx",
    "zaq1xsw2",
    "zaq1zaq1",
    "zary",
    "zdxfcgvh",
    "zebra",
    "zebras",
    "zelda",
    "zelda1",
    "zelda123",
    "zeldapass",
    "zeldazelda",
    "zena69",
    "zenderzen1102",
    "zener",
    "zenerdiode",
    "zenith",
    "zephyr",
    "zephyr123",
    "zeppelin",
    "zepplin",
    "zeus",
    "zeusx",
    "zhaoqian",
    "zhaozhua",
    "zhengkun",
    "zhenyan",
    "zhi",
    "zhigang",
    "zhishun",
    "zhiwei",
    "zhixin",
    "zhongguo",
    "zhongmin",
    "ziggy",
    "zigzag",
    "zimbra",
    "zimmerman",
    "zinfandel",
    "zita",
    "ziv",
    "ziyou",
    "zmodem",
    "zoltan",
    "zombie",
    "zonda",
    "zoomer",
    "zoran",
    "zork",
    "zorkmid",
    "zoro",
    "zorro",
    "zpasswordz",
    "zsexdrcft",
    "zulu",
    "zuperman",
    "zxc",
    "zxc123",
    "zxcv",
    "zxcvb",
    "zxcvbn",
    "zxcvbnm",
    "zxcvbnm,./",
    "zxin",
    "zxin10",
    "zztop",
    "zz-top",
    "zzz",
    "zzzz",
    "zzzzz",
    "zzzzzz",
    "zzzzzzz",
    "zzzzzzzz"
];

@Injectable()
export class PasswordStrength {
    constructor() {    
        this.passwordStrengthChecker = new taiPasswordStrength.PasswordStrength();

        this.passwordStrengthChecker.addCommonPasswords(COMMON_PASSWORDS);
    }

    private passwordStrengthChecker;

    public check(password) : PasswordStrengthResult {
        return this.passwordStrengthChecker.check(password);
    }
}